import {ActivatedRoute, Router} from '@angular/router';
/* tslint:disable:indent */
import {BehaviorSubject, combineLatest, Subject, Subscription} from 'rxjs';
import {DiffuseurService} from '../../../../formulaires/services/diffuseurs.service';
import {FormulaireServiceService} from '../../../../formulaires/services/formulaire-service.service';
import {ErrorWafConverterService} from '../../../../shared/services/error-waf-converter.service';
import {AvisItem} from '../../../lister-avis-de-pub/model/avis.item';
import {Avis} from '../../../../../models/avis';
import {ViewportScroller} from '@angular/common';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {StepperBuilderService} from 'src/app/modules/avisDePub/creer/services/stepper.builder.service';
import {SteppeurMessages} from 'src/app/modules/shared/models/component-messages/stepper-messages';
import {StepperModels} from 'src/app/modules/shared/models/stepper/stepper-model';
import * as stepperValidation from 'src/assets/dynamic/creer/stepper-validation.json';
import * as stepperConfig from 'src/assets/dynamic/creer/stepper-config.json';
import {FormsEnum} from '../../../../../models/enums/forms.enum';
import {TypeFacturation} from '../../../../formulaires/common/models/type.facturation';
import {TypeFacturation as TypeFacturationDila} from 'src/app/models/eforms/dila/TypeFacturation';
import {TypeFacturationComponent} from '../typeFacturation/type-facturation.component';
import {Preference} from '../../../preferences-avis-de-pub/model/preference';
import {PreferenceType} from '../../../../shared/models/enum/preferenceType';
import {AvisExtractorService} from '../../../../formulaires/common/services/avis-extractor.service';
import {FacturationService} from '../../../../formulaires/common/services/facturation/facturation.service';
import {FormulaireExtractorDispatcherService} from '../../../../formulaires/services/formulaire-extractor-dispatcher.service';
import {CanNavigateInStepperService} from '../../../../shared/services/can-navigate-in-stepper.service';
import {HttpService} from '../../../../shared/services/http.service';
import {LogService} from '../../../../shared/services/log.service';
import {AvisService} from '../../../services/avis-service';
import {DefaultFormulaireCritere} from '../choix-formulaire/model/default.formulaire.critere';
import {TranslateService} from '@ngx-translate/core';
import * as jsonNoticeType from '../../../../../../../src/assets/dynamic/creer/formSections/E_FORM_notice-types.json';
import {TypeIndexation} from '../../../../formulaires/common/models/type.indexation';
import {debounceTime, finalize, first, take, takeUntil} from 'rxjs/operators';
import {Flux} from '../../../../../models/flux';
import {AvisDataTransferService} from '../../../../shared/services/avis-data-transfer.service';
import moment from 'moment';
import {EformPrefillService} from '../../../../formulaires/eforms/services/eform-prefill.service';
import {EformDuplicableEntityService} from '../../../../formulaires/eforms/services/eform-duplicable-entity.service';
import {InformationComponent} from '../../../../shared/modals/information/information.component';
import {ContenuPdf} from '../../../../formulaires/common/models/contenuPdf';
import {IdSchemeService} from '../../../../formulaires/eforms/services/id-scheme.service';
import cloneDeep from 'lodash.clonedeep';
import {SpinnerVisibilityService} from 'ng-http-loader';
import {EformDynamicListService} from '../../../../formulaires/eforms/services/eform-dynamic-list.service';
import {Section} from '../../../../../models/section';
import {EformsSubjectService} from '../../../../formulaires/eforms/services/eforms-subject.service';
import {EformDataService} from '../../../../formulaires/eforms/services/eform-data.service';
import {DuplicableElementsIdSchemeEnum} from '../../../../formulaires/eforms/enum/duplicable-elements-id-scheme.enum';
import {ENoticeTypeXsd} from '../../../../../models/enums/enotice-type-xsd.enum';
import {IndexTrackerService} from '../../../../formulaires/eforms/services/index-tracker.service';
import {DuplicableElementPathEnum} from "../../../../formulaires/eforms/enum/duplicable-element-id-path.enum";
import {EformConditionsV2Service} from "../../../../formulaires/eforms/services/eform-conditions-v2.service";
import {EFormsOrgService} from "../../../../formulaires/eforms/services/e-forms-org.service";
import {EformsToolsService} from "../../../../formulaires/eforms/services/e-forms-tools.service";

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepperComponent implements OnInit, OnDestroy {

  public LOG: LogService = new LogService(StepperComponent);
  public selectedDiffuseurs: Array<number> = [];
  public enabledDiffuseurs: Array<number> = [];
  public flux: Flux[];
  public avisItem: AvisItem;
  public form: FormGroup;
  public stepStats: Map<string, boolean>;
  public indexPage: any;
  // le socle statique d'un formulaire à alimenter avec les steps dynamiques
  public stepper;
  public steppeurMessage = new SteppeurMessages();
  public formulaireName = null;
  public formulaireIntitule = null;
  public formulaireCategory = null;
  public refAvisLie = null;
  public referenceAvis;
  public avisId;
  public critereId;
  public onModification = false;
  public disabled = false;
  // choix du formulaire
  public defaultCritere: DefaultFormulaireCritere;
  public defaultCritereBhs: BehaviorSubject<DefaultFormulaireCritere> = new BehaviorSubject(null);
  public currentFormOnUpdate: BehaviorSubject<string> = new BehaviorSubject(null);
  public currentJson: BehaviorSubject<any> = new BehaviorSubject(null);
  public showDiff = false;
  public linkForRouter = '';
  public facturation: TypeFacturation;
  public facturationDila: TypeFacturationDila;
  public preferenceTypeFacturation = PreferenceType.FACTURATION;
  @ViewChild(TypeFacturationComponent) typeFacturationComponent: TypeFacturationComponent;
  public indexation: TypeIndexation;
  public update = false;
  // Tant que false en mode édition, le contenu du stepper (dont la section 0.1) reste masqué
  // derrière un écran de chargement, le temps que useDataToUpdate() positionne le bon indexPage.
  public isAvisDataReady = true;
  // l'index du formulaire adapté démarre à null pour éviter de l'afficher
  public fadIndex = null;
  public isBOAMPorJOUE: boolean;
  public isSHALorPS: boolean;
  public diffuseurAD: boolean;
  public formFullName = null;
  public noticeSubType = null;
  public simplifiedFormName = null;
  public json = JSON;
  alreadyEmitted = false;
  subs: Map<string, Subscription> = new Map();
  isEform: boolean = false;
  public facturationIndex: number;
  public indexationIndex: number;
  public annonceurIndex: number;
  public validationIndex: number;
  public test: boolean = false;
  private readonly _EnabledDiffuseurs = 'enabledDiffuseurs';
  private readonly _FormulaireAsset = 'formulaireAsset';
  private noticeType: any = jsonNoticeType;
  private idStepChange: number = null;
  private duplicableSectionsName = [];
  private isFirstSave: boolean = true;
  private unsubscribeduplicableSection$ = new Subject<void>();
  private stepId = null;
  private isEndRecupDuplicableSectionName: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private unsubscribeEndDuplicableSectionName$ = new Subject<void>();
  private lotOrPart: string = null;
  private isAfterPrerempOrNoPreremp = true;
  // ✅ FIX 2025-12-23: Flag pour éviter la double sauvegarde au chargement initial
  private initialLoadSaveDone = false;
  // ✅ FIX 2025-12-23: Flag pour éviter le doublon de get-avis lors du premier saveForm en édition
  private skipGetAvisAfterFirstSave = false;
  // ✅ FIX 2025-12-24: Flag pour empêcher les double-clics sur le bouton Envoyer
  public isSending = false;
  // ✅ FIX 2026-02-02: Flag pour éviter l'ajout multiple d'organisations de recours
  private secondOrgAlreadyAdded = false;
  // ✅ FIX 2026-02-04: Capturer l'état de création initial (avant la première sauvegarde)
  // Cette variable reste à true si on a créé l'avis (même après la 1ère sauvegarde)
  // Elle est à false si on a ouvert un avis existant en édition
  private wasInitiallyCreationMode = false;
  // 🔧 FIX Firefox 2026-04-07: Sur Firefox, après getAvisWithAllDuplicablesElements (switchMap),
  // le backend indexe les lots en 0-based (LOT-0001=index0, LOT-0002=index1...) au lieu de
  // 1-based (index0=template, LOT-0001=index1...) sur Chrome. On applique un offset de -1 sur les appels getDuplicableEntity.
  private isZeroBasedLotIndex = false;
  // ✅ FIX 2026-04-03: Dernier lot actif quand on a quitté une step-lot.
  // Utilisé pour détecter un retour au même lot depuis une step non-lot (ex: validation → lot3).
  private lastActiveLotValue: number | null = null;


  constructor(
    private stepperBuilderService: StepperBuilderService,
    private httpClient: HttpService,
    private activatedRoute: ActivatedRoute,
    private avisService: AvisService,
    private diffuseurService: DiffuseurService,
    private cd: ChangeDetectorRef,
    private modalService: NgbModal,
    private canNavigateInStepperService: CanNavigateInStepperService,
    private facturationService: FacturationService,
    private avisExtractorService: AvisExtractorService,
    private viewPortScroller: ViewportScroller,
    private formulaireExtractorDispatcherService: FormulaireExtractorDispatcherService,
    private errorWafConverterService: ErrorWafConverterService,
    private translateService: TranslateService,
    private router: Router,
    private avisDataTransferService: AvisDataTransferService,
    private eformPrefillService: EformPrefillService,
    private eformDuplicableEntityService: EformDuplicableEntityService,
    private indexTrackerService: IndexTrackerService,
    private formulaireService: FormulaireServiceService,
    private idSchemeService: IdSchemeService,
    private spinner: SpinnerVisibilityService,
    private eformDynamicListService: EformDynamicListService,
    private eformsSubjectService: EformsSubjectService,
    private eformDataService: EformDataService,
    private eformConditionsV2Service: EformConditionsV2Service,
    private eFormsOrgService: EFormsOrgService,
    private eformsToolsService: EformsToolsService
  ) {
  }

  ngOnDestroy(): void {
    this.formulaireName = null;
    this.formulaireIntitule = null;
    this.formulaireCategory = null;
    this.stepperBuilderService.resetSteps();
    this.form = null;
    this.stepperBuilderService.notice.next(null);
    this.stepperBuilderService.duplicableSection.next(null);
    this.canNavigateInStepperService.setReferenceParent(null);
    this.canNavigateInStepperService.formulairevalues = null;
    this.canNavigateInStepperService.linkableNotices = [];
    this.canNavigateInStepperService.selectedDiffuseurInitial = [];
    this.canNavigateInStepperService.isSelectedDiffuseurADMoreThanZero = false;
    this.subs.forEach((s) => s.unsubscribe());
    this.canNavigateInStepperService.eformCreatingChange = false;
    this.canNavigateInStepperService.eformMotifChange = null;
    this.canNavigateInStepperService.eformIdPreviousForm = null;
    this.canNavigateInStepperService.eformVersionPreviousForm = null;
    this.canNavigateInStepperService.eformIdParentNotice = null;
    this.canNavigateInStepperService.idParentFluxBoampEform = null;
    this.canNavigateInStepperService.isAvisParentSelected = false;
    this.canNavigateInStepperService.isCreerAvisLierSelected = false;
    this.canNavigateInStepperService.isAvisLierNational = false;
    this.canNavigateInStepperService.isAvisLieCreate = false;
    this.canNavigateInStepperService.avisLieCreateFirstSave = false;
    this.canNavigateInStepperService.eformAllInputCreated = false;
    this.canNavigateInStepperService.avisIdParent = null;
    this.subs = new Map();
    this.errorWafConverterService.clear();
    this.avisDataTransferService.setFormData(null);
    this.avisDataTransferService.jsonCSV = {};
    this.avisDataTransferService.contenuPdf = new ContenuPdf();
    this.stepperBuilderService.errorsEformBySection = [];
    this.stepperBuilderService.PDFAvisLiesSetted.next(null);
    this.stepperBuilderService.prefillDone.next(false);
    this.stepperBuilderService.avisId = null;
    this.eformDuplicableEntityService.initialSectionDuplicableIndex = -1;
    this.eformDynamicListService.lotName.next([]);
    this.unsubscribeduplicableSection$.next();
    this.unsubscribeduplicableSection$.complete();
    this.unsubscribeEndDuplicableSectionName$.next();
    this.unsubscribeEndDuplicableSectionName$.complete();
    this.eformDuplicableEntityService.listDuplicableEntity.next([]);
    this.eformDynamicListService.lotName.next([]);
    this.eformDuplicableEntityService.actualSectionDuplicableCount = 0;
    this.eformDuplicableEntityService.stepperLotPageCount = 0;
    this.eformDuplicableEntityService.actuaEntityIndex = -1;
    this.eformsSubjectService.idSchemeListSubject.next([]);
    this.eformDuplicableEntityService.currentAvisId.next(null);
    this.eformDuplicableEntityService.isCreationButBeforeFirstSave.next(false);
    this.eformDuplicableEntityService.isAvisWithAllDuplicablesElementsReady.next(false);
    this.eformDuplicableEntityService.isDataDuplicableEntityReady.next(false);
    this.eformDuplicableEntityService.isFormReady.next(false);
    sessionStorage.removeItem('refConsultation');
    this.stepperBuilderService.isSavedBack.next(false);
    this.eformDuplicableEntityService.resetDuplicableEntitiesSubjects();
    this.canNavigateInStepperService.avisLieModalite = 0;
    this.indexTrackerService.resetIndexes();
    this.avisExtractorService.clearSessionStorageDuplicableElement();
    this.eformConditionsV2Service.resetFlatFields();
    // ✅ FIX 2026-02-20: Réinitialiser tous les flags de conditions pour éviter qu'ils ne restent bloqués après duplication
    this.eformConditionsV2Service.resetAllConditionFlags();
    // 🔧 FIX 2026-04-22: Nettoyer le callback LOT index
    this.eformDuplicableEntityService.onLotIndexChanged = null;
    // ✅ FIX 2025-12-23: Réinitialiser le flag de sauvegarde initiale
    this.initialLoadSaveDone = false;
    this.skipGetAvisAfterFirstSave = false;
    this.isSending = false;
  }

  upOrDown(isDown): string {
    if (isDown) {
      return 'keyboard_arrow_up';
    } else {
      return 'keyboard_arrow_down';
    }
  }

  public ngOnInit() {
    // ✅ FIX 2025-12-23: Initialiser à true pour permettre la première sauvegarde
    this.stepperBuilderService.isSavedBack.next(true);
    this.eformDuplicableEntityService.listDuplicableEntity.next([]);
    this.eformDynamicListService.lotName.next([]);
    this.eformsSubjectService.idSchemeListSubject.next([]);

    // 🔧 FIX 2026-04-22: Enregistrer le callback pour synchroniser displayedRealIndex
    // lors de chaque navigation vers un lot via getDuplicableEntity.
    // Cela garantit que les flatFields utilisent le bon index de lot, évitant que les données
    // du lot 2 soient écrasées par celles du lot 1 lors de l'ouverture d'une sous-section.
    this.eformDuplicableEntityService.onLotIndexChanged = (type: string, index: number) => {
      this.eformConditionsV2Service.setDisplayedRealIndex(type, index);
    };

    this.stepperBuilderService.stepper.subscribe(value => {
      this.stepper = value;
      if (this.stepper?.findIndex(step => 'GR-Lot' === step.eformName) > -1) {
        this.lotOrPart = 'LOT';
      } else if (this.stepper?.findIndex(step => 'GR-Part' === step.eformName) > -1) {
        this.lotOrPart = 'PAR';
      } else {
        this.lotOrPart = null;
      }
      if (value != null && value.length > 1) {
        // Trouver la step Validation (dernière step avec libelle "Validation")
        const validationStep = value.find(step => step.libelle === 'Validation');

        if (validationStep && validationStep.sections && validationStep.sections.length >= 4) {
          // Utiliser les codes réels des sections de la step Validation
          this.facturationIndex = validationStep.sections[0].code;
          this.indexationIndex = validationStep.sections[1].code;
          this.annonceurIndex = validationStep.sections[2].code;
          this.validationIndex = validationStep.sections[3].code;
        } else {
          // Fallback: calcul basé sur la longueur du stepper
          this.facturationIndex = 0.1 + (value?.length - 1);
          this.indexationIndex = 0.2 + (value?.length - 1);
          this.annonceurIndex = 0.3 + (value?.length - 1);
          this.validationIndex = 0.4 + (value?.length - 1);
        }

        if (this.fadIndex && this.fadIndex === 1) {
          this.facturationIndex = null;
          this.indexationIndex = null;
          // Utiliser les codes réels si disponibles
          if (validationStep && validationStep.sections && validationStep.sections.length >= 2) {
            this.annonceurIndex = validationStep.sections[0].code;
            this.validationIndex = validationStep.sections[1].code;
          } else {
            this.annonceurIndex = 0.1 + (value?.length - 1);
            this.validationIndex = 0.2 + (value?.length - 1);
          }
        }
        if (this.fadIndex && this.fadIndex !== 1) {
          this.annonceurIndex = +Number(this.annonceurIndex + 0.1).toFixed(1);
          this.validationIndex = +Number(this.validationIndex + 0.1).toFixed(1);
        }
      }
    });
    this.eformDynamicListService.getLotName().subscribe(e => {
      this.duplicableSectionsName = e;
    });
    if (!this.canNavigateInStepperService.isAvisLieCreate) {
      this.stepperBuilderService.stepper.pipe(first(value => value != null && value.length > 1 && this.avisId)).subscribe(() => {
        this.stepId = this.stepId ?? 1;
        if (this.lotOrPart != null) {
          this.eformDuplicableEntityService.getDuplicableEntity(this.avisId, 0, this.lotOrPart).subscribe(init => {
            if (init === null) {
              this.eformDuplicableEntityService.missDuplicableSectionInit = true;
              this.eformDuplicableEntityService.duplicableSectionChargeEnded.pipe(first(value => value === true)).subscribe(() => {
                this.cd.detectChanges();
                // ✅ FIX 2025-12-23: Éviter la double sauvegarde au chargement initial
                if (!this.initialLoadSaveDone) {
                  this.initialLoadSaveDone = true;
                  this.saveForm(this.indexPage, this.indexPage);
                }
                // ✅ FIX 2026-04-03: Utiliser savedStepValue si disponible.
                const initLotValue1 = this.resolveInitialLotValue();
                this.eformDuplicableEntityService.getDuplicableEntity(this.avisId, initLotValue1, this.lotOrPart).subscribe(duplicableSection => {
                  this.eformDuplicableEntityService.currentDuplicableSectionValue.next(duplicableSection);
                  this.isEndRecupDuplicableSectionName.next(false);
                  this.isEndRecupDuplicableSectionName.pipe(first(isEnded => isEnded === true)).subscribe(() => {
                    this.eformDynamicListService.setLotName(cloneDeep(this.form)?.controls?.eforms, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('LOT') || e.id.includes('PAR')));
                  });
                  this.prepareIdSchemeListSubject();
                });
              });
            } else {
              // 🔧 FIX Firefox 2026-04-07 v2: En mode création (wasInitiallyCreationMode=true) avec init≠null,
              // le backend a indexé les lots en 0-based → index0=LOT-0001(id=1), index1=LOT-0002(id=2)...
              // PROBLÈME : getDuplicableEntity(0) est appelé de façon asynchrone. Sa réponse peut arriver
              // APRÈS que l'utilisateur a navigué vers lot 2 ou 3 (via le premier save).
              // Dans ce cas, currentDuplicableSectionValue.next(init) écrasait les données du lot courant
              // avec les données du lot 1 (id=1) → tous les lots montraient id=1.
              // SOLUTION : Vérifier le lot courant à la réception de la réponse.
              if (this.wasInitiallyCreationMode) {
                this.isZeroBasedLotIndex = false;
                const currentStepIdx = Math.floor(Number(this.indexPage));
                const isOnDuplicableStep = this.eformDuplicableEntityService.isSectionDuplicableStep(currentStepIdx);
                const currentLotValue = isOnDuplicableStep ? (this.stepper[currentStepIdx]?.value ?? 1) : 1;
                // En mode création, getDuplicableEntity(0)=template (sans données). Les vrais lots sont aux indices 1,2,3...
                const targetLotIndex = currentLotValue;
                this.eformDuplicableEntityService.getDuplicableEntity(this.avisId, targetLotIndex, this.lotOrPart).subscribe(targetSection => {
                  // ✅ FIX 2026-04-24: Race condition lot1 écrase lot2 lors de la navigation rapide.
                  const nowStepIdx = Math.floor(Number(this.indexPage));
                  const nowIsOnDuplicableStep = this.eformDuplicableEntityService.isSectionDuplicableStep(nowStepIdx);
                  const nowLotValue = nowIsOnDuplicableStep ? (this.stepper[nowStepIdx]?.value ?? -1) : -1;
                  if (nowIsOnDuplicableStep && nowLotValue !== targetLotIndex) {
                    // L'utilisateur a navigué vers un autre lot pendant le chargement → ne pas écraser ses données
                    console.warn(`⚠️ Race condition lots : réponse lot ${targetLotIndex} ignorée car utilisateur sur lot ${nowLotValue}`);
                    return;
                  }
                  this.eformDuplicableEntityService.currentDuplicableSectionValue.next(targetSection);
                  this.isEndRecupDuplicableSectionName.next(false);
                  this.isEndRecupDuplicableSectionName.pipe(first(isEnded => isEnded === true)).subscribe(() => {
                    this.eformDynamicListService.setLotName(cloneDeep(this.form)?.controls?.eforms, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('LOT') || e.id.includes('PAR')));
                  });
                  this.prepareIdSchemeListSubject();
                });
              } else {
                // Mode édition : index0=template, index1=premier lot réel → getDuplicableEntity(stepValue) correct
                const initLotValue2 = this.resolveInitialLotValue();
                this.eformDuplicableEntityService.getDuplicableEntity(this.avisId, initLotValue2, this.lotOrPart).subscribe(duplicableSection => {
                  this.eformDuplicableEntityService.currentDuplicableSectionValue.next(duplicableSection);
                  this.isEndRecupDuplicableSectionName.next(false);
                  this.isEndRecupDuplicableSectionName.pipe(first(isEnded => isEnded === true)).subscribe(() => {
                    this.eformDynamicListService.setLotName(cloneDeep(this.form)?.controls?.eforms, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('LOT') || e.id.includes('PAR')));
                  });
                  this.prepareIdSchemeListSubject();
                });
              }
            }
          });
        }
      });
    }
    if (this.canNavigateInStepperService.isAvisLieCreate === true || this.canNavigateInStepperService.isCreerAvisLierSelected === true) {
      this.eformDuplicableEntityService.duplicableSectionAvisLieIsCreated.pipe(first(value => value === true)).subscribe(() => {
        this.getFormulaireAsset(this.canNavigateInStepperService.currentFormulaire, 1);
        this.eformDuplicableEntityService.getDuplicableEntity(this.avisId, 1, this.lotOrPart).pipe(takeUntil(this.unsubscribeduplicableSection$)).subscribe(duplicableSection => {
          this.eformDuplicableEntityService.currentDuplicableSectionValue.next(duplicableSection);
        });
        this.prepareIdSchemeListSubject();
      });
    }
    this.stepperBuilderService.stepper.next(JSON.parse(JSON.stringify(stepperConfig.stepper)));
    this.form = new FormGroup({}); //
    // ce champ permet de gérer le cas de submit
    this.form.addControl('submitted', new FormControl(false));
    this.indexPage = this.stepperBuilderService.getSubsectionIndex();
    this.referenceAvis =
      this.activatedRoute.snapshot.paramMap.get('numeroAvisPub');

    //Si on edite un avis
    if (this.referenceAvis) {
      this.isAvisDataReady = false;
      this.spinner.show();
      this.update = true;
      this.linkForRouter = '/avisdepublicite/editerAvisPub/' + this.referenceAvis;
      this.onModification = true;

      combineLatest([
        this.avisService.getAvisByReference(this.referenceAvis),
        this.diffuseurService.getBoampAndJoueIds()
      ]).pipe(
        finalize(() => {
          this.isAvisDataReady = true;
          this.cd.detectChanges();
        })
      ).subscribe(results => {
        const data = results[0];
        const ids = results[1];
        this.useDataToUpdate(data, ids);
        this.isAvisDataReady = true;
        this.cd.detectChanges();
      });
    } else {
      this.canNavigateInStepperService.tempSelectedDiffuseur = [];
      this.linkForRouter = '/avisdepublicite/creerAvisPub';
      //Si c'est une creation on veut savoir si la premiere sauvegarde a eu lieu (avant aucune entité n'est en base et c'est le front qui les créées)
      this.eformDuplicableEntityService.isCreationButBeforeFirstSave.next(true);
      // ✅ FIX 2026-02-04: Capturer l'état de création initial
      this.wasInitiallyCreationMode = true;
      this.showDiff = true;
      if (this.formulaireName) {
        this.getFormulaireAsset(this.formulaireName);
        // d'ici, forcer les valeurs de l'avis parent
      }
      const referenceParent: Avis = this.canNavigateInStepperService.getReferenceParent();
      if (referenceParent instanceof Avis) {
        if (this.formulaireName) {
          this.getFormulaireAsset(this.formulaireName, 2);
        }
        referenceParent.flux.forEach((f) => {
          this.enabledDiffuseurs.push(f.id.diffuseurId);
        });
      }
      this.selectedDiffuseurs = this.canNavigateInStepperService.selectedDiffuseurInitial;
      this.canNavigateInStepperService.tempSelectedDiffuseur = this.selectedDiffuseurs;
      if (this.fadIndex == 1) {
        this.indexation = null;
        this.facturationDila = null;
      } else {
        this.indexation = new TypeIndexation();
        this.facturationDila = new TypeFacturation();
      }
    }
    this.stepperBuilderService.getStats().subscribe((data) => {
      this.stepStats = data;
    });

    if (this.canNavigateInStepperService.isCreerAvisLierSelected) {
      if (!this.canNavigateInStepperService.isEdit) {
        this.eformDuplicableEntityService.isCreationButBeforeFirstSave.next(true);
      }
      this.suivant();
    }

    // ✅ ROBUSTE 2025-12-16: Système de sauvegarde immédiate sans debounce
    // Ce Subject est utilisé pour les sauvegardes qui nécessitent une confirmation de fin
    // (changement d'accordéon, suppression d'élément, etc.)
    this.eformDuplicableEntityService.requestImmediateSave$.pipe(
      takeUntil(this.unsubscribeduplicableSection$)
    ).subscribe(() => {
      this.cd.detectChanges();
      // La sauvegarde est effectuée immédiatement
      // saveCompleted$ sera émis dans saveForm() via isSavedBack
      this.saveFormWithCallback(this.indexPage, this.indexPage, () => {
        this.eformDuplicableEntityService.saveCompleted$.next();
      });
    });

    // Conserver l'ancien mécanisme avec debounce pour les autres cas (rétrocompatibilité)
    this.eformDuplicableEntityService.needSaveAfterChangeAccordion.pipe(
      takeUntil(this.unsubscribeduplicableSection$),
      debounceTime(100)
    ).subscribe(bool => {
      if (bool) {

        this.cd.detectChanges();
        // ✅ FIX 2025-12-23: Marquer la sauvegarde initiale comme faite pour éviter les doublons
        this.initialLoadSaveDone = true;
        this.saveForm(this.indexPage, this.indexPage);
        this.eformDuplicableEntityService.needSaveAfterChangeAccordion.next(false);
      }
    });
  }

  getValidationIndex(): number {
    return this.validationIndex?.toString().includes('.') ? Number.parseInt(this.validationIndex.toString().split('.')[0]) : 0;
  }

  onFacturationPreferenceSelected(preference: Preference): void {
    this.typeFacturationComponent?.chargeDonneePreference(preference);
  }

  useDataToUpdate(data, ids) {
    if (data?.jsonSaisieFormulaire?.sourceAppProfilAcheteurInfos) {
      this.avisDataTransferService.sourceAppProfilAcheteurInfos = data.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos;
    }
    this.eformDuplicableEntityService.currentAvisId.next(data.avisId);

    // ✅ FIX 2026-03-04: Activer le flag isLoadingAvisLie pour désactiver les conditions
    // pendant le chargement initial de l'avis (édition ou duplication).
    // Cela évite que les champs conditionnés (comme BT-5421-Lot) soient vidés
    // lors de la construction du formulaire si leur condition n'est pas encore satisfaite.
    this.eformConditionsV2Service.setLoadingAvisLie(true);

    // ✅ FIX 2026-03-05: Activer AUSSI isLoadingLot pour protéger les champs conditionnels des LOT
    // pendant le chargement initial (duplication ou édition).
    // Sans cela, BT-5421-Lot est vidé car isFieldForbidden=true avant que les données ne soient chargées.
    this.eformConditionsV2Service.setLoadingLot(true);

    // 🔧 FIX 2026-03-09: Les flags isLoadingAvisLie et isLoadingLot devraient désactiver
    // les validations pendant le chargement pour les avis de modification aussi

    // 🔧 FIX 2026-02-13: Attendre que getAvisWithAllDuplicablesElements soit terminé
    // AVANT de mettre à jour avisWithElementsDuplicable. Cela garantit que tous les
    // éléments duplicables (TPA, CON, TEN, etc.) sont correctement chargés depuis la BDD,
    // pas seulement ceux présents dans le JSON de l'avis sauvegardé.
    this.eformDuplicableEntityService.getAvisWithAllDuplicablesElements(this.eformDuplicableEntityService.currentAvisId.getValue()).subscribe(() => {
      // avisWithElementsDuplicable est maintenant mis à jour par getAvisWithAllDuplicablesElements
      // avec toutes les données des éléments duplicables depuis la BDD
    });
    // ✅ FIX 2025-12-23: Éviter le doublon de get-avis après le premier saveForm
    this.skipGetAvisAfterFirstSave = true;

    // IMPORTANT: writeDateWithCorrectTimeZone transforme l'objet en minuscules
    this.writeDateWithCorrectTimeZone(data);

    // 🔧 FIX 2026-03-09: Initialiser les structures manquantes APRÈS writeDateWithCorrectTimeZone
    // car writeDateWithCorrectTimeZone fait une copie profonde qui écrase nos modifications
    if (this.canNavigateInStepperService.eformCreatingChange) {
      this.initMissingStructuresForChangeNotice(data);
    }

    if (!this.canNavigateInStepperService.isCreerAvisLierSelected) {
      this.currentJson.next(data);
    } else {
      if (!this.canNavigateInStepperService.isEdit) {
        this.eformPrefillService.isPrefillAvisLie = true;
        this.eformPrefillService.tempNotice = data;
      } else {
        this.currentJson.next(data);
      }
    }

    // récupérer la liste des diffuseurs
    this.avisId = data.avisId;
    this.stepperBuilderService.avisId = this.avisId;
    this.critereId = data.critere?.id;
    this.flux = data.flux;
    // setter le nom du formulaire dans le stepBuilder
    const formCode: any = data.formulaire.code;
    this.stepperBuilderService.formulaire = formCode;
    this.canNavigateInStepperService.currentFormulaire = formCode;
    this.form?.controls?.formIntitule?.setValue(data.formulaire.intitule);
    // dans le cas d'un formulaire adapté
    if (this.stepperBuilderService.formulaire.toString() === 'FORM_AD') {
      this.facturation = data.jsonSaisieFormulaire.ann.formAD.facturation;
    }

    this.stepId = data.jsonSaisieFormulaire.stepId;
    this.facturationDila = data.jsonSaisieFormulaire.ann.facturation;
    this.indexation = data.jsonSaisieFormulaire.ann.indexation;
    this.isBOAMPorJOUE = data.jsonSaisieFormulaire.isBOAMPorJOUE;
    this.isSHALorPS = data.jsonSaisieFormulaire.isSHALorPS;
    this.formulaireService.actualFormIdAnnEmetteur.next(data.jsonSaisieFormulaire.ann.idAnnEmetteur);
    data.flux.forEach((f) => {
      this.selectedDiffuseurs.push(f.id.diffuseurId);
    });
    if (!this.subs.has(this._EnabledDiffuseurs)) {
      this.subs.set(this._EnabledDiffuseurs,
        this.canNavigateInStepperService.subReferenceParent().subscribe(referenceParent => {
          if (referenceParent instanceof Avis) {
            referenceParent.flux.forEach((f) => {
              this.enabledDiffuseurs.push(f.id.diffuseurId);
            });
          }
        })
      );
    }

    this.canNavigateInStepperService.tempSelectedDiffuseur = this.selectedDiffuseurs;
    this.canNavigateInStepperService.isSelectedDiffuseurADTemp(ids[0], ids[1]);
    this.formulaireIntitule = data.formulaire.intitule;
    this.formulaireName = data.formulaire.code;
    this.refAvisLie = data.refAvisLie;
    this.formulaireCategory = this.formulaireExtractorDispatcherService.categorize(this.formulaireName);
    this.defaultCritere = new DefaultFormulaireCritere();
    this.defaultCritere.avisCode = data.critere?.typeAvis.code;
    this.defaultCritere.avisLibelle = data.critere?.typeAvis.libelle;

    this.defaultCritere.montantCode = data.critere?.montantMarche.code;
    this.defaultCritere.montantLibelle =
      data.critere?.montantMarche.libelle;

    this.defaultCritere.marcheCode = data.critere?.typeMarche.code;
    this.defaultCritere.marcheLibelle = data.critere?.typeMarche.libelle;

    this.defaultCritere.organismeCode = data.critere?.typeOrganisme.code;
    this.defaultCritere.organismeLibelle =
      data.critere?.typeOrganisme.libelle;
    this.showDiff = true;
    if (this.defaultCritere.avisCode) {
      this.defaultCritereBhs.next(this.defaultCritere);
    } else {
      const form: any = data.formulaire;
      form.criteres = null;
      this.currentFormOnUpdate.next(form);
    }


    if (this.canNavigateInStepperService.linkableNotices.length > 0) {
      if (!this.subs.has(this._FormulaireAsset)) {
        this.subs.set(this._FormulaireAsset,
          this.canNavigateInStepperService.subReferenceParent().subscribe(referenceParent => {
            if (!referenceParent && this.formulaireName) {
              this.getFormulaireAsset(this.formulaireName, 1);
            }
          }));
      }
    } else if (data.jsonSaisieFormulaire.stepId == null) {
      this.getFormulaireAsset(this.formulaireName, 3);
      this.suivant(false);
    } else {
      // ✅ FIX 2026-03-02: Restaurer indexPage et stepValue depuis les données sauvegardées
      let fullStepId = 1;
      const encodedStepId = data.jsonSaisieFormulaire.stepId || 0;

      if (encodedStepId >= 100) {
        // Décoder: mainStep = floor(encoded / 100), subSection = encoded % 100
        const mainStep = Math.floor(encodedStepId / 100);
        const subSection = encodedStepId % 100;
        fullStepId = subSection > 0 ? Number(mainStep + '.' + subSection) : mainStep;
      } else {
        // Ancien format (avant le fix), utiliser tel quel
        fullStepId = encodedStepId;
      }

      // ✅ FIX 2026-03-02: IMPORTANT - Remplacer stepId encodé par stepId décodé dans data
      // pour que TOUS les composants (nationaux et eforms) reçoivent le stepId décodé
      data.jsonSaisieFormulaire.stepId = fullStepId;

      // Décoder stepValue depuis le champ version
      let decodedStepValue = null;
      if (data.jsonSaisieFormulaire.version?.startsWith('SV:')) {
        decodedStepValue = Number(data.jsonSaisieFormulaire.version.substring(3));
      }

      // La condition > 0.4 évite d'écraser indexPage si on est dans les étapes de sélection (0.1, 0.2, 0.3, 0.4)
      if (fullStepId > 0.4) {
        this.indexPage = fullStepId;
        this.stepId = fullStepId;

        // Sauvegarder stepValue pour retrouver le bon lot/part
        if (decodedStepValue) {
          this.stepperBuilderService.savedStepValue = decodedStepValue;
        }
      }
      this.getFormulaireAsset(this.formulaireName, fullStepId);
    }
    this.stepperBuilderService.prefillDone.pipe(first(bool => bool == true)).subscribe(bool => {
      // ✅ FIX 2026-04-08: Mettre à jour this.indexation avec les données du prefill eform
      if (this.indexation != null && this.avisDataTransferService.avis?.jsonSaisieFormulaire?.ann?.indexation) {
        this.indexation = this.avisDataTransferService.avis.jsonSaisieFormulaire.ann.indexation;
      }
      if (this.form) {
        this.cd.detectChanges();
        // ✅ FIX 2025-12-23: Éviter la double sauvegarde au chargement initial
        if (!this.initialLoadSaveDone) {
          this.initialLoadSaveDone = true;
          this.saveForm(this.indexPage, this.indexPage);
        }
      }
    });
  }

  writeDateWithCorrectTimeZone = (obj) => {
    Object.keys(obj).forEach(key => {
      if (JSON.stringify(obj[key]) != null && JSON.stringify(obj[key]) != 'null') {
        const found = JSON.stringify(obj[key]).match(/^"\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}\+\d{2}:\d{2}"$/g);
        if (found) {
          obj[key] = moment(obj[key]).format('yyyy-MM-DDTHH:mm:ssZZ');
        }
      }
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        this.writeDateWithCorrectTimeZone(obj[key]);
      }
    });
  };


  getStepStatus(stepIndex: number): string {
    if (this.indexPage?.toString().split('.')[0] == stepIndex) {
      return 'EtapeCourante';
    } else if (this.indexPage > stepIndex) {
      return 'EtapeCheck';
    } else if (this.indexPage < stepIndex) {
      return 'EtapeSuivante';
    }
  }

  getStepStatusLabel(stepIndex: number): string {
    const status = this.getStepStatus(stepIndex);
    switch (status) {
      case 'EtapeCourante':
        return 'en cours';
      case 'EtapeCheck':
        return 'complétée';
      case 'EtapeSuivante':
      default:
        return 'non complétée';
    }
  }

  isStepAriaDisabled(stepIndex: number): boolean {
    return this.disableStep(stepIndex) || this.disableIfErrorInSection();
  }

  getStepAriaLabel(stepIndex: number, stepLibelle: string): string {
    const statusLabel = this.getStepStatusLabel(stepIndex);
    const isDisabled = this.isStepAriaDisabled(stepIndex);
    const disabledSuffix = isDisabled ? ' - désactivé' : '';
    return `Étape ${stepIndex} (${statusLabel}${disabledSuffix}) : ${stepLibelle}`;
  }

  getSubStepIndicator(stepIndex: number, subStepIndex: number): string {
    const completeIndex = stepIndex + '.' + subStepIndex;
    if (this.indexPage === +completeIndex) {
      return 'encours';
    } else if (this.indexPage > +completeIndex) {
      return 'complete';
    } else {
      return 'noncomplete';
    }
  }

  getSubStepStatusLabel(stepIndex: number, subStepIndex: number): string {
    const indicator = this.getSubStepIndicator(stepIndex, subStepIndex);
    switch (indicator) {
      case 'encours':
        return 'en cours';
      case 'complete':
        return 'complétée';
      case 'noncomplete':
      default:
        return 'non complétée';
    }
  }

  isSubStepDisabled(stepIndex: number): boolean {
    return this.disableStep(stepIndex) || this.disableIfErrorInSection();
  }

  getSubStepAriaLabel(stepIndex: number, subStepIndex: number, sectionIntitule: string): string {
    const statusLabel = this.getSubStepStatusLabel(stepIndex, subStepIndex);
    const isDisabled = this.isSubStepDisabled(stepIndex);
    const disabledSuffix = isDisabled ? ' - désactivé' : '';
    return `Étape ${stepIndex}.${subStepIndex} (${statusLabel}${disabledSuffix}) : ${sectionIntitule}`;
  }

  getFormulaireAsset(form: FormsEnum, stepId = 0) {
    this.httpClient
      .get('assets/dynamic/creer/formSections/' + form + '.json', null, {basePath: ''})
      .pipe(take(1))
      .subscribe((data) => {
        if (!this.formulaireIntitule) {
          this.formulaireIntitule = this.form?.controls.formIntitule.value;
        }
        this.initStepper(form, data);
        if (this.canNavigateInStepperService.eformMotifChange) {
          this.formulaireIntitule = this.formulaireIntitule + ' | ' + this.translateService.instant(this.canNavigateInStepperService.eformMotifChange);
        }
        // ✅ FIX 2026-03-02: Pour les eforms, ne pas appeler goTo ici car le stepper n'est pas encore complètement construit
        // Le goTo sera appelé dans le callback du subscribe de notice une fois que tout est prêt
        const isEformFormulaire = form.toString().includes('E_FORM');
        if (stepId != null && !isEformFormulaire) {
          this.goTo(stepId, stepId !== 0 && stepId != null);
        }
        this.updateFormFullName();
      }, (error) => {
        console.error('error:', error);
        throw new Error(error);
      }).add(e => {
        this.stepperBuilderService.notice.pipe(first(notice => notice != null)).subscribe(notice => {
          if (notice) {
            this.updateStepperIfNeeded();
            this.isEform = this.canNavigateInStepperService.currentFormulaire.includes('E_FORM');
            // ✅ FIX 2026-04-08: Pour les eforms en création, mettre à jour this.indexation
            // avec les données du prefill AVANT cd.detectChanges() qui rend <app-type-indexation>
            if (this.isEform && this.indexation != null && this.avisDataTransferService.avis?.jsonSaisieFormulaire?.ann?.indexation) {
              this.indexation = this.avisDataTransferService.avis.jsonSaisieFormulaire.ann.indexation;
            }
            if (!this.canNavigateInStepperService.eformCreatingChange) {
              // ✅ FIX 2026-03-02: Attendre que le stepper soit complètement chargé avant de naviguer
              const waitForStepper = () => {
                if (this.stepper && this.stepper.length > 1) {
                  const finalStepId = this.adjustStepIdForDuplicableSection(stepId);
                  this.goTo(finalStepId, finalStepId !== 0 && finalStepId != null);
                } else {
                  setTimeout(waitForStepper, 50);
                }
              };
              waitForStepper();
            }
            this.cd.detectChanges();
          }
        });
      }
    );
  }

  /**
   * cette méthode permet d'initialser le stepper avec le json d'un formulaire
   * @param data
   */
  initStepper(form: FormsEnum, data) {
    if (form.toString().includes('E_FORM')) {
      this.isEform = true;

      // ✅ Définir le nom du formulaire courant dans le service de conditions
      // Cela permettra de charger les métadonnées (Field avec forbiddenConditionV2)
      this.eformConditionsV2Service.setCurrentFormName(form.toString());

      //Dans le cas du formulaire eform, on va chercher en BDD le nombre de lots à charger avant toute chose
      //Sinon la creation des lots va prendre plus de temps suite à l'appel en BDD et ils vont apparaitre en dernier
      if (this.avisId) {
        this.isEndRecupDuplicableSectionName.next(false);
        this.isEndRecupDuplicableSectionName.pipe(first(isEnded => isEnded === true)).subscribe(() => {
          this.initEformStepper(data, this.eformDuplicableEntityService.actualSectionDuplicableCount);
        });
        this.prepareIdSchemeListSubject();
      } else {
        this.initEformStepper(data, 0);
      }
    } else {
      //Dans le cas des formulaires nationaux, on recupere les steps du json directement
      //Et on ajoute toutes les sections ou sous-sections dans le steppeur
      data.stepper.forEach(step => {
        this.stepper.push(step);
        if (step.sections != undefined) {
          step.sections.forEach(sub => {
            this.stepperBuilderService.subSections.push(sub.code);
          });
        } else {
          this.stepperBuilderService.subSections.push(step.id);
        }
      });
    }
    const stats = new Map<string, boolean>();
    this.stepperBuilderService.updateStats(stats);
    const temp: any = this.stepperBuilderService.addFAD(this.indexPage, this.fadIndex, this.stepper,
      this.formulaireName, this.canNavigateInStepperService.isSelectedDiffuseurADMoreThanZero);
    this.fadIndex = temp.fadIndex;
    this.updateStepperIfNeeded();
    this.cd.detectChanges();
  }

  isDuplicatedStep(index) {
    // Utiliser le stepper lui-même (source synchrone) plutôt que listDuplicableEntity (mis à jour de manière asynchrone)
    // pour éviter que le bouton supprimer ne déborde sur la section suivante (ex: Résultat) après suppression d'un lot
    if (!this.stepper[index]) return false;
    const step = this.stepper[index];
    const isLotOrPart = step.eformName === 'GR-Lot' || step.eformName === 'GR-Part';
    if (!isLotOrPart) return false;
    const duplicableSectionCount = this.stepper.filter(s => s.eformName === 'GR-Lot' || s.eformName === 'GR-Part').length;
    return duplicableSectionCount > 1;
  }

  addValidation() {
    let validation = JSON.parse(JSON.stringify(stepperValidation.stepper));
    validation[0].id = this.stepper.length;
    validation[0].value = this.stepper.length;
    validation[0].sections.forEach(s => {
      s.id += this.stepper.length - 1;
      s.code += this.stepper.length - 1;
    });

    if (this.isEform) {
      this.stepperBuilderService.subSections.push(Number(this.stepper.length + '.' + 1));
      this.stepperBuilderService.subSections.push(Number(this.stepper.length + '.' + 2));
      this.stepperBuilderService.subSections.push(Number(this.stepper.length + '.' + 3));
      this.stepperBuilderService.subSections.push(Number(this.stepper.length + '.' + 4));
    } else {
      this.stepperBuilderService.subSections.push(Number(this.stepper.length + '.' + 1));
      this.stepperBuilderService.subSections.push(Number(this.stepper.length + '.' + 2));
    }
    this.stepper.push(validation[0]);
    this.stepperBuilderService.stepper.next(this.stepper);
  }

  precedent() {
    if (this.indexPage == 2 && this.canNavigateInStepperService.isCreerAvisLierSelected && this.canNavigateInStepperService.isAvisLierNational) {
      return;
    }
    this.canNavigateInStepperService.canNavigate(this.stepperBuilderService.getSubsectionIndex(), this.form, true).subscribe(bool => {
      if (bool) {
        let actualPageIndex = JSON.parse(JSON.stringify(this.indexPage));
        if (!this.isEform && actualPageIndex > 0.4) {
          this.validateStep(actualPageIndex, false, false);
          if (actualPageIndex === this.facturationIndex) {
            this.stepperBuilderService.setIsCheckValidate('_STEP_ID_SepSep_TypeFacturation', true);
          } else if (actualPageIndex === this.indexationIndex) {
            this.stepperBuilderService.setIsCheckValidate('_STEP_ID_SepSep_TypeIndexation', true);
          } else if (actualPageIndex === this.annonceurIndex) {
            this.stepperBuilderService.setIsCheckValidate('_STEP_ID_SepSep_idAnnonceur', true);
          } else {
            this.stepperBuilderService.setIsCheckValidate('_STEP_ID_' + actualPageIndex, true);
          }
        }
        this.stepperBuilderService.removeIndex();
        this.indexPage = this.stepperBuilderService.getSubsectionIndex();
        this.openCloseStepIfNeeded(this.indexPage, actualPageIndex);
        this.updateFacturation();
        this.saveForm(this.indexPage, actualPageIndex);
        this.viewPortScroller.scrollToPosition([0, 0]);
        this.cd.detectChanges();
        if (!this.isEform && this.indexPage > 0.4) {
          this.validateStep(this.indexPage, false, false);
        }
      }
    });
  }

  suivant(updateFact = true) {
    if (this.canNavigateInStepperService.isCreerAvisLierSelected && !this.canNavigateInStepperService.isAvisParentSelected && this.indexPage == 0.2) {
      return;
    }
    this.canNavigateInStepperService.canNavigate(this.stepperBuilderService.getSubsectionIndex(), this.form).subscribe(bool => {
      if (bool) {
        this.canNavigateInStepperService.canNext(this.stepperBuilderService.getSubsectionIndex(), this.form, this.isBOAMPorJOUE, this.fadIndex, this.annonceurIndex).subscribe(bool2 => {
          if (bool2) {
            let previousPageIndex = JSON.parse(JSON.stringify(this.indexPage));
            if (!this.isEform && previousPageIndex > 0.4) {
              this.validateStep(previousPageIndex, false, false);
              if (previousPageIndex === this.facturationIndex) {
                this.stepperBuilderService.setIsCheckValidate('_STEP_ID_SepSep_TypeFacturation', true);
              } else if (previousPageIndex === this.indexationIndex) {
                this.stepperBuilderService.setIsCheckValidate('_STEP_ID_SepSep_TypeIndexation', true);
              } else if (previousPageIndex === this.annonceurIndex) {
                this.stepperBuilderService.setIsCheckValidate('_STEP_ID_SepSep_idAnnonceur', true);
              } else {
                this.stepperBuilderService.setIsCheckValidate('_STEP_ID_' + previousPageIndex, true);
              }
            }
            this.stepperBuilderService.addIndex();
            this.indexPage = this.stepperBuilderService.getIndex(previousPageIndex);
            if (this.canNavigateInStepperService.isAvisParentSelected) {
              this.eformPrefillService.isPrefillAvisLie = true;
              this.eformPrefillService.prefillAvisLieEform(2, this.canNavigateInStepperService.getReferenceParent().formulaire.code, this.canNavigateInStepperService.currentFormulaire, this.canNavigateInStepperService.getReferenceParent().reference, this.eformPrefillService.tempNotice.jsonSaisieFormulaire.ann);
              if (this.canNavigateInStepperService.isAvisLierNational) {
                this.indexPage = 2;
                this.stepperBuilderService.index = 5;
              } else {
                this.indexPage = 1;
                // la variable index 4 correspond à la step 1.0 dans le stepperService (0.1,0.2,0.3,0.4,1)
                this.stepperBuilderService.index = 4;
              }
            }

            this.canNavigateInStepperService.isAvisParentSelected = false;
            this.openCloseStepIfNeeded(previousPageIndex, this.indexPage);
            this.getFormulaire();
            if (updateFact) {
              this.updateFacturation();
            }
            const temp: any = this.stepperBuilderService.addFAD(this.indexPage,
              this.fadIndex,
              this.stepper,
              this.formulaireName,
              this.canNavigateInStepperService.isSelectedDiffuseurADMoreThanZero);

            this.fadIndex = temp.fadIndex;
            // dans le cas d'un avis non lies, on save après le suivant
            // dans le cas d'un avis lies , on attend le preremplissage pour sauvegarder (après le 1er suivant)
            if (this.indexPage >= 1 && updateFact === true && !this.eformPrefillService.isPrefillAvisLie) {
              this.saveForm(this.indexPage, previousPageIndex);
            } else if (this.indexPage >= 1 && updateFact === true && this.eformPrefillService.isPrefillAvisLie && this.stepperBuilderService.prefillDone.getValue()) {
              this.saveForm(this.indexPage, previousPageIndex);
            }
            this.viewPortScroller.scrollToPosition([0, 0]);
            this.cd.detectChanges();
            if (!this.isEform && previousPageIndex > 0.4) {
              this.validateStep(this.indexPage, false, false);
            }
          }
        });
      }
    });
  }

  noFocus($event) {
    $event.preventDefault();
  }

  disableStep(frontIndex) {
    if (frontIndex == 1 && this.canNavigateInStepperService.isCreerAvisLierSelected && this.canNavigateInStepperService.isAvisLierNational) {
      return true;
    }
    //Desactive la step d'introduction une fois qu'on l'a quittée
    return (frontIndex === 0 && !this.indexPage?.toString().startsWith(String(0))) ||
      //Desactive les autres step tant qu'on est à l'étape 0 (choix du formulaire et des diffuseurs obligatoire)
      (frontIndex > 0 && this.indexPage.toString().startsWith(String(0)));
  }

  openCloseStepIfNeeded(previousPageIndex, actualPageIndex) {
    if (!actualPageIndex === previousPageIndex) {
      //On verifie si la step actuelle commence par le meme nombre que la précédente
      //Si on change de step, on ferme toutes les autres et on ouvre la nouvelle
      if (!actualPageIndex.toString().startsWith(previousPageIndex.toString().split('.')[0])) {
        this.stepper.forEach(step => step.required = false);
        //On verifie que la step existe tjs avant de la mettre à jour
        if (this.stepper[actualPageIndex.toString().split('.')[0]]) {
          this.stepper[actualPageIndex.toString().split('.')[0]].required = true;
        }
      }
    } else {
      //On verifie si la step actuelle commence par le meme nombre que la précédente
      //Si on change de step, on ferme toutes les autres et on ouvre la nouvelle
      if (actualPageIndex == undefined) {
        actualPageIndex = 1;
      }
      if (!previousPageIndex.toString().startsWith(actualPageIndex.toString().split('.')[0])) {
        this.stepper.forEach(step => step.required = false);
        //On verifie que la step existe tjs avant de la mettre à jour
        if (this.stepper[actualPageIndex.toString().split('.')[0]]) {
          this.stepper[actualPageIndex.toString().split('.')[0]].required = true;
        }
      }
    }
    if (this.referenceAvis && this.stepper) {
      this.stepper[0].required = false;
    }
    this.stepperBuilderService.stepper.next(this.stepper);
  }

  goToSection(stepIndex, sectionIndex) {
    if (stepIndex !== 0) {
      //On ajoute 1 au section index car 1.0 n'existe pas, on commence à 1.1
      this.goTo(Number(stepIndex + '.' + (sectionIndex + 1)));
    }
  }

  /**
   * ✅ FIX 2026-03-02: Ajuster stepId pour les sections duplicables (Lot/Part)
   * Si stepValue est sauvegardé, trouve le bon lot/part dans le stepper
   */
  adjustStepIdForDuplicableSection(stepId: number): number {
    // Vérifier que le stepper est complètement chargé
    if (!this.stepper || this.stepper.length <= 1) {
      return stepId;
    }

    if (!this.isEform || !stepId || !this.stepperBuilderService.savedStepValue) {
      this.stepperBuilderService.savedStepValue = null;
      return stepId;
    }

    const baseStepIndex = Math.floor(Number(stepId));
    const subSection = stepId.toString().includes('.') ? stepId.toString().split('.')[1] : null;

    if (!this.stepper[baseStepIndex]) {
      this.stepperBuilderService.savedStepValue = null;
      return stepId;
    }

    const currentStep = this.stepper[baseStepIndex];
    const isDuplicable = currentStep.eformName === 'GR-Lot' || currentStep.eformName === 'GR-Part';

    if (!isDuplicable) {
      this.stepperBuilderService.savedStepValue = null;
      return stepId;
    }

    // Trouver le step qui a le bon stepValue ET RÉCUPÉRER SON INDEX
    let targetStepIndex = -1;
    for (let i = 0; i < this.stepper.length; i++) {
      const step = this.stepper[i];
      if (step.value === this.stepperBuilderService.savedStepValue &&
          (step.eformName === 'GR-Lot' || step.eformName === 'GR-Part')) {
        targetStepIndex = i;
        break;
      }
    }

    if (targetStepIndex !== -1) {
      this.stepperBuilderService.savedStepValue = null;
      const newStepId = subSection ? Number(targetStepIndex + '.' + subSection) : targetStepIndex;
      return newStepId;
    }

    this.stepperBuilderService.savedStepValue = null;
    return stepId;
  }

  goTo(desiredIndex: number, byPass = false) {
    if (this.disableIfErrorInSection() || (desiredIndex == 1 && this.canNavigateInStepperService.isCreerAvisLierSelected && this.canNavigateInStepperService.isAvisLierNational)) {
      return;
    }
    let actualPageIndex = JSON.parse(JSON.stringify(this.indexPage));
    if (this.canNavigateInStepperService.currentFormulaire.includes('E_FORM')) {
      this.isEform = true;
    }
    if (!this.isEform && actualPageIndex > 0.4) {
      this.validateStep(actualPageIndex, false, false);
      if (actualPageIndex === this.facturationIndex) {
        this.stepperBuilderService.setIsCheckValidate('_STEP_ID_SepSep_TypeFacturation', true);
      } else if (actualPageIndex === this.indexationIndex) {
        this.stepperBuilderService.setIsCheckValidate('_STEP_ID_SepSep_TypeIndexation', true);
      } else if (actualPageIndex === this.annonceurIndex) {
        this.stepperBuilderService.setIsCheckValidate('_STEP_ID_SepSep_idAnnonceur', true);
      } else {
        this.stepperBuilderService.setIsCheckValidate('_STEP_ID_' + actualPageIndex, true);
      }
    }
    const indexToGo = this.stepperBuilderService.findIndexPageForSpecificStep(desiredIndex);

    this.updateFacturation();
    if (this.indexPage >= indexToGo) {
      if (this.canNavigateInStepperService.canGoTo(this.indexPage, indexToGo) || byPass) {
        this.stepperBuilderService.index =
          this.stepperBuilderService.subSections.findIndex(
            (item) => item === indexToGo
          );
        this.openCloseStepIfNeeded(this.indexPage, indexToGo);
        this.indexPage = this.stepperBuilderService.getSubsectionIndex() ?? 1;
        if (byPass === false) {
          this.saveForm(this.indexPage, actualPageIndex);
        }
        this.cd.detectChanges();
        if (!this.isEform && actualPageIndex != this.indexPage) {
          this.validateStep(this.indexPage, false, false);
        }
      }
    } else {
      this.canNavigateInStepperService.canNext(this.stepperBuilderService.getSubsectionIndex(), this.form, this.isBOAMPorJOUE, this.fadIndex, this.annonceurIndex).subscribe(bool => {
        if (bool || this.indexPage >= indexToGo) {
          if (this.canNavigateInStepperService.canGoTo(this.indexPage, indexToGo) || byPass) {
            this.stepperBuilderService.index =
              this.stepperBuilderService.subSections.findIndex(
                (item) => item === indexToGo
              );
            this.openCloseStepIfNeeded(this.indexPage, indexToGo);
            this.indexPage = this.stepperBuilderService.getSubsectionIndex() ?? 1;
            if (byPass === false) {
              this.saveForm(this.indexPage, actualPageIndex);
            }
            this.cd.detectChanges();
            if (!this.isEform && actualPageIndex != this.indexPage) {
              this.validateStep(this.indexPage, false, false);
            }
          }
        }
      });
    }
  }

  valider() {
    this.stepperBuilderService.index =
      this.stepperBuilderService.subSections.findIndex(
        (item) => item === this.stepperBuilderService.getSubsectionIndex()
      );
    this.indexPage = this.stepperBuilderService.getSubsectionIndex();
    this.getFormulaire();
  }

  /**
   * cette méthode permet de se connecter au subject qui contient le
   */
  getFormulaire(desiredIndex = 0) {
    this.stepperBuilderService.getFormulaire().pipe(first()).subscribe((data) => {
      if (data !== this.formulaireName || this.canNavigateInStepperService.creerAvisLierSelected) {
        this.formulaireName = data;
        if(data.toString().includes('E_FORM_')) {
          DuplicableElementPathEnum.initializePaths(ENoticeTypeXsd[data].toLowerCase());
        }
        this.getFormulaireAsset(this.formulaireName, desiredIndex);
        this.formulaireCategory = this.formulaireExtractorDispatcherService.categorize(this.formulaireName);
        this.canNavigateInStepperService.creerAvisLierSelected = false;
      }
    });
  }

  /**
   * Recupération du nom du formulaire et de son type via E_FORM_notice-types.json
   */
  updateFormFullName() {
    if (this.formulaireName) {
      this.simplifiedFormName = this.formulaireName?.replace('E_FORM_', '');
      this.noticeSubType = this.noticeType.default.noticeSubTypes.find(notice => notice.subTypeId === this.simplifiedFormName);
      if (this.noticeSubType && !this.canNavigateInStepperService.eformMotifChange) {
        this.translateService.get(this.noticeSubType._label).subscribe((label: string) => {
          this.formFullName = label;
        });
      } else {
        this.formFullName = this.formulaireIntitule;
      }
    }
  }

  updateFacturation() {
    if (this.stepperBuilderService.formulaire === FormsEnum.FORM_AD) {
      // dans le cas d'un formulaire adapté ne pas écraser la valeur
      return;
    }
    if (!this.form) {
      return null;
    }
    const controls = this.avisExtractorService.getMap_ControlsID_ControlsIDWithoutStepIdCommonId(this.form);
    this.facturation = this.facturationService.getFacturation(this.form, this.formulaireName, controls);
  }

  sendForm() {
    // ✅ FIX 2025-12-24: Empêcher les double-clics sur le bouton Envoyer
    if (this.isSending) {
      return;
    }
    this.isSending = true;

    let shouldReturn = false;
    // Note: La validation est déjà effectuée dans avisExtractorService.sendForm() via validateForm()
    // L'appel à validateStep ici était redondant et causait un doublon d'appel à /schematron/validate
    for (let i = 0; i < this.avisDataTransferService.reference.length; i++) {
      if (this.avisDataTransferService.reference[i].includes(this.referenceAvis)) {
        const refAvisLie = this.avisDataTransferService.refAvisLie[i];
        // Vérifier que l'avis a bien une référence d'avis lié avant de faire l'appel API
        if (refAvisLie && refAvisLie !== '' && refAvisLie !== null && refAvisLie !== undefined) {
          this.avisService.getAvisByReference(refAvisLie).subscribe(
            (a: Avis) => {
              if (a.statut != 'PUBLIE' && a.statut != null) {
                shouldReturn = true;
                this.isSending = false;
                const modalRef = this.modalService.open(InformationComponent);
                modalRef.componentInstance.content = 'Cet avis ne peut être publié car il existe un autre avis en cours de publication dans cette procédure.';
              }
            }
          );
        }
        break;
      }
    }
    if (shouldReturn) {
      this.isSending = false;
      return;
    }
    if (this.stepperBuilderService.formulaire == null) {
      this.isSending = false;
      return;
    }

    //Verifie si on doit retirer un schemeId qu'on aurait prérempli et non utilisé
    //Ici on remplace definitivement le form par l'updatedForm (on a supprimé les objets contenant uniquement un schemeId et non-obligatoire)
    this.idSchemeService.checkIfSchemeIdHaveToBeDeleted(this.form, this.formulaireName).then(updatedForm => {
      this.form = updatedForm;
      this.avisExtractorService.sendForm(this.form, this.avisId, this.referenceAvis, this.critereId, this.flux, this.facturationIndex, this.isBOAMPorJOUE, this.avisDataTransferService?.avis?.jsonSaisieFormulaire?.ann,() => {
          this.isSending = false;
        }
      ).subscribe(
        {
          next: (data) => {
            if (data) {
              this.onModification = true;
              this.avisId = data?.avis?.avisId;
              this.stepperBuilderService.avisId = this.avisId;
              this.referenceAvis = data?.avis?.reference;
            }
          },
          error: () => {
            this.isSending = false;
          },
          complete: () => {
            this.isSending = false;
          }
        }
      );
    }).catch(() => {
      this.isSending = false;
    });
  }

  getIsCheckValid(stepId) {
    return this.stepperBuilderService.getIsCheckValidate(stepId);
  }

  isStepRepeatable(sectionIndex: number) {
    return this.stepper[sectionIndex]?.repeatable;
  }

  getStepIndexIfRepeatable(sectionIndex) {
    if (this.stepper[sectionIndex].repeatable) {
      return '-' + this.stepper[sectionIndex].value.toString().padStart(4, '0');
    }
  }

  getFullNameSection(sectionIndex, stepLibelle) {
    if (stepLibelle.includes('group|name|ND-Lot') || stepLibelle.includes('group|name|ND-Part')) {
      let value = this.duplicableSectionsName[this.stepper[sectionIndex].value - 1];
      if (value) {
        return ' - ' + value;
      }
    }
  }

  saveFormAndExit(indexPage) {
    this.saveForm(indexPage, indexPage, true);
  }

  /**
   * ✅ FIX 2026-04-03: Résout l'index de lot correct pour le chargement initial.
   *
   * Problème : au démarrage, stepId vaut 1 par défaut (ligne `this.stepId = this.stepId ?? 1`)
   * car getAvisByReference n'a pas encore répondu. Cela entraîne getDuplicableEntity(LOT, 1)
   * qui charge les données du lot1 au lieu du lot courant (ex: lot3).
   *
   * Stratégie de résolution (ordre de priorité) :
   * 1. savedStepValue — défini par useDataToUpdate depuis version='SV:X' (si getAvisByReference répond vite)
   * 2. stepper[floor(indexPage)].value — si indexPage est une étape de lot (> 4)
   * 3. stepper[stepId].value — comportement historique (fallback)
   * 4. 1 — dernier recours
   */
  private resolveInitialLotValue(): number {
    if (this.stepperBuilderService.savedStepValue > 0) {
      return this.stepperBuilderService.savedStepValue;
    }
    const floorIndexPage = Math.floor(this.indexPage);
    if (floorIndexPage > 4 && this.stepper && this.stepper[floorIndexPage]?.value > 0) {
      return this.stepper[floorIndexPage].value;
    }
    if (this.stepper && this.stepper[this.stepId]) {
      return this.stepper[this.stepId]?.value ?? 1;
    }
    return 1;
  }

  saveForm(indexPage, actualPageIndex, isSaveAndExit = false) {
    if (this.stepperBuilderService.formulaire == null || !this.form) {
      return;
    }
    // ✅ FIX 2025-12-23: Empêcher les sauvegardes parallèles
    if (this.stepperBuilderService.isSavedBack.getValue() === false) {
      // Un blocage du garde est un fonctionnement attendu (pas une erreur) — contexte ajouté
      // (INC0110604) pour pouvoir corréler avec la section concernée en prod.
      console.warn('Sauvegarde bloquée car sauvegarde parallèle', {avisId: this.avisId, indexPage, actualPageIndex});
      return;
    }
    this.stepperBuilderService.isSavedBack.next(false);

    // ✅ FIX 2026-04-03 v4 (source-first): stepValue doit toujours représenter le lot
    // de la page ACTUELLE (source = actualPageIndex), pas celle de destination.
    // Ex: lot3→lot4 doit sauvegarder avec SV:3 (lot3), pas SV:4.
    // Fallback sur la destination uniquement si la source n'est pas un lot (ex: validation→lot3).
    let stepValue = null;
    if (this.isEform && actualPageIndex) {
      const actualStepIndex = Math.floor(Number(actualPageIndex));
      if (this.stepper && this.stepper[actualStepIndex] && this.eformDuplicableEntityService.isSectionDuplicableStep(actualStepIndex)) {
        stepValue = this.stepper[actualStepIndex].value;
        // On mémorise le dernier lot actif pour le check isSameLot (voir ci-dessous)
        this.lastActiveLotValue = stepValue;
      }
    }
    // 🔧 FIX 2026-04-23: Supprimé le fallback sur indexPage (destination) qui corrompait les données.
    // Quand la source (actualPageIndex) n'est pas un step LOT, stepValue DOIT rester null.
    // Sinon, fixCurrentLotId() remplaçait l'ID du lot dans le form (données du lot source)
    // par l'ID du lot de destination, écrasant les données du lot de destination en BDD.
    // Exemple: step1→lot2 envoyait les données de lot1 avec l'ID LOT-0002.

    // ✅ FIX INC0110604: finalize garantit le reset de isSavedBack même si la sauvegarde échoue
    // (HttpService.process() transforme une erreur HTTP en complete() silencieux via catchError+EMPTY,
    // donc next() n'est jamais appelé) — sans ce reset, le guard plus haut bloque silencieusement
    // toutes les sauvegardes suivantes, y compris celles des sections suivantes, jusqu'au reload.
    this.avisExtractorService.saveForm(this.form, this.avisId, this.referenceAvis, this.critereId, this.onModification, this.flux,
      indexPage, actualPageIndex, stepValue, this.canNavigateInStepperService.getReferenceParent()?.reference, this.refAvisLie).pipe(
      finalize(() => this.stepperBuilderService.isSavedBack.next(true))
    ).subscribe(
      {
        next: (data) => {

          // Permet de forcer getDuplicableEntity pour le save initial même quand stepIndexToGo === actualIndex
          const wasFirstSaveAndPreremp = this.eformDuplicableEntityService.isFirstSaveAndPreremp.getValue();
          this.eformDuplicableEntityService.currentAvisId.next(data.avisId);
          this.avisId = data.avisId;
          this.stepperBuilderService.avisId = this.avisId;
          if ((!this.linkForRouter?.includes('editerAvisPub') || this.canNavigateInStepperService.avisLieModalite > 0) && this.isFirstSave && this.isEform) {
            this.isEndRecupDuplicableSectionName.next(false);
            this.isEndRecupDuplicableSectionName.pipe(first(isEnded => isEnded === true)).subscribe(() => {
              this.addLotsToStepper(this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('LOT') || e.id.includes('PAR')).length, false);
              this.updateStepperIfNeeded();
              this.cd.detectChanges();
              //Pour les lots, on a modifié l'envoie au back pour le preremplissage lors du create mais pas le form
              //Donc à la premiere sauvegarde, on supprime le lot initial dans le form pour ne pas ecraser les données préremplies du lot 1
              const firstItemName = ENoticeTypeXsd[this.stepperBuilderService.formulaire].toLowerCase();
              const lotsPath = 'eforms.' + firstItemName + '.procurementprojectlot';
              this.eformDataService.removeLastControl(this.form, lotsPath);
            });
            this.eformDuplicableEntityService.firstSaveIsEndedForAvisLie.next(true);
            this.isFirstSave = false;
          }
          if (!this.eformDuplicableEntityService.isFirstSaveAndPreremp.getValue() && !this.skipGetAvisAfterFirstSave) {
            this.eformDuplicableEntityService.getAvisWithAllDuplicablesElements(this.stepperBuilderService.avisId).subscribe(() => {
              this.cd.detectChanges();
            });
          } else {
            this.eformDuplicableEntityService.isFirstSaveAndPreremp.next(false);
            // ✅ FIX 2025-12-23: Réinitialiser le flag après le premier saveForm
            this.skipGetAvisAfterFirstSave = false;
          }
          let stepIndexToGo = +indexPage.toString().split('.')[0];
          let actualIndex = +actualPageIndex.toString().split('.')[0];
          //Si la step sur laquelle on arrive est un lot et qu'il est different de celui dejà chargé,
          //on met à jour les données.
          // ✅ FIX 2026-04-03: wasFirstSaveAndPreremp permet de forcer getDuplicableEntity lors du
          // save initial (6.3→6.3) pour corriger le chargement erroné du mauvais lot au démarrage.
          if (this.eformDuplicableEntityService.isSectionDuplicableStep(stepIndexToGo) && (stepIndexToGo !== actualIndex || wasFirstSaveAndPreremp)) {
            const lotValueToGo = this.stepper[stepIndexToGo]?.value;
            const sourceStepIndex = Math.floor(Number(actualPageIndex));
            const sourceIsLot = this.stepper && this.stepper[sourceStepIndex]
              && this.eformDuplicableEntityService.isSectionDuplicableStep(sourceStepIndex);
            const isSameLot = !sourceIsLot
              && this.lastActiveLotValue !== null
              && lotValueToGo === this.lastActiveLotValue;

            if (isSameLot) {
              this.prepareIdSchemeListSubject(data.avisId);
              this.updateDataAndRedirect(data, isSaveAndExit);
            } else {
              const effectiveLotValue = lotValueToGo;
              this.eformDuplicableEntityService.getDuplicableEntity(this.avisId, effectiveLotValue, this.lotOrPart).subscribe(duplicableSection => {
                this.eformDuplicableEntityService.currentDuplicableSectionValue.next(duplicableSection);
                this.prepareIdSchemeListSubject(data.avisId);
                this.updateDataAndRedirect(data, isSaveAndExit);
              });
            }
          } else {
            this.prepareIdSchemeListSubject(data.avisId);
            this.updateDataAndRedirect(data, isSaveAndExit);
          }
          this.stepperBuilderService.isSavedBack.next(true);
        }
      }
    );
  }

  /**
   * ✅ ROBUSTE 2025-12-16: Sauvegarde avec callback de confirmation
   * Permet d'exécuter du code APRÈS que la sauvegarde soit terminée
   * sans dépendre d'un timing fixe (debounce)
   */
  saveFormWithCallback(indexPage, actualPageIndex, onComplete: () => void) {
    if (this.stepperBuilderService.formulaire == null || !this.form) {
      onComplete(); // Appeler le callback même si pas de sauvegarde
      return;
    }
    this.stepperBuilderService.isSavedBack.next(false);

    // 🔧 FIX 2026-04-23: stepValue = lot de la source (page actuelle) uniquement.
    // PAS de fallback sur la destination (indexPage) — cela corrompait les données du lot de destination.
    let stepValue = null;
    if (this.isEform && actualPageIndex) {
      const actualStepIndex = Math.floor(Number(actualPageIndex));
      if (this.stepper && this.stepper[actualStepIndex] && this.eformDuplicableEntityService.isSectionDuplicableStep(actualStepIndex)) {
        stepValue = this.stepper[actualStepIndex].value;
        this.lastActiveLotValue = stepValue;
      }
    }
    // 🔧 FIX 2026-04-23: Même correction que saveForm — pas de fallback destination
    // ✅ FIX INC0110604: finalize garantit le reset de isSavedBack même si la sauvegarde échoue
    // (cf. commentaire équivalent dans saveForm() ci-dessus).
    // INC0110604 : un échec HTTP silencieux (HttpService.process() -> catchError
    // +EMPTY) complète l'Observable sans jamais appeler next() ni error() — sans le garde
    // reponseRecue ci-dessous, onComplete() ne serait jamais rappelé dans ce cas, bloquant
    // indéfiniment les appelants (accordéon/bouton d'ajout de lot eForms). Un simple
    // finalize(() => onComplete()) appellerait le callback trop tôt (avant la fin de
    // getAvisWithAllDuplicablesElements() dans le cas next), d'où ce garde plutôt qu'un finalize.
    let reponseRecue = false;
    this.avisExtractorService.saveForm(this.form, this.avisId, this.referenceAvis, this.critereId, this.onModification, this.flux,
      indexPage, actualPageIndex, stepValue, this.canNavigateInStepperService.getReferenceParent()?.reference, this.refAvisLie).pipe(
      finalize(() => this.stepperBuilderService.isSavedBack.next(true))
    ).subscribe(
      {
        next: (data) => {
          reponseRecue = true;
          this.eformDuplicableEntityService.currentAvisId.next(data.avisId);
          this.avisId = data.avisId;
          this.stepperBuilderService.avisId = this.avisId;
          this.prepareIdSchemeListSubject(data.avisId);
          this.stepperBuilderService.isSavedBack.next(true);

          // ✅ FIX 2025-12-18: Attendre que getAvisWithAllDuplicablesElements soit terminé
          // AVANT d'appeler le callback, pour garantir que avisWithElementsDuplicable
          // contient les données à jour lors du rechargement des éléments
          if (!this.eformDuplicableEntityService.isFirstSaveAndPreremp.getValue() && !this.skipGetAvisAfterFirstSave) {
            // FIX INC0110604 : même mécanisme que reponseRecue ci-dessus, un niveau plus bas
            // getAvisWithAllDuplicablesElements() passe aussi par HttpService et peut compléter silencieusement
            // (EMPTY) sur erreur, sans jamais appeler next() : sans ce garde, onComplete() ne serait jamais rappelé.
            let rechargementRecu = false;
            this.eformDuplicableEntityService.getAvisWithAllDuplicablesElements(this.stepperBuilderService.avisId)
              .subscribe({
                next: () => {
                  rechargementRecu = true;
                  this.cd.detectChanges();
                  onComplete();
                  },
                error: () => {
                  rechargementRecu = true;
                  onComplete();
                  },
                complete: () => {
                  if (!rechargementRecu) {
                    onComplete();
                  }
                }
            });
          } else {
            this.eformDuplicableEntityService.isFirstSaveAndPreremp.next(false);
            // ✅ FIX 2025-12-23: Réinitialiser le flag après le premier saveFormWithCallback
            this.skipGetAvisAfterFirstSave = false;
            onComplete();
          }
        },
        error: () => {
          // En cas d'erreur, appeler le callback quand même pour ne pas bloquer
          reponseRecue = true;
          onComplete();
        },
        complete: () => {
          // FIX INC0110604 : cas de l'échec HTTP silencieux (ni next, ni error).
          if (!reponseRecue) {
            onComplete();
          }
        }
      }
    );
  }

  newStep(stepIndex: number) {
    //On incrémente l'index
    this.indexTrackerService.addDuplicableElement(this.lotOrPart);

    // 🔧 FIX 2026-01-22: Mettre à jour actuallyIndexLotOrPar AVANT addDuplicableFieldsByType
    // pour que le scan du formulaire utilise le bon index dès le début.
    // Le nouvel index est le nombre actuel d'éléments - 1 (car 0-based)
    const newLotIndex = this.indexTrackerService.getLastIndex(this.lotOrPart) - 1;
    this.eformDuplicableEntityService.actuallyIndexLotOrPar = newLotIndex;
    this.eformConditionsV2Service.setDisplayedRealIndex(this.lotOrPart, newLotIndex);

    //On ajoute le flatFields qui va recupérer les informations
    this.eformConditionsV2Service.addDuplicableFieldsByType(this.lotOrPart);

    // 🔧 FIX Firefox 2026-04-07: Utiliser saveFormWithCallback pour garantir que la sauvegarde
    // est terminée AVANT d'appeler addNewDuplicableEntity.
    // L'ancien pattern (saveForm + attente isEndRecupDuplicableSectionName) était fragile :
    // saveForm() contient un guard (isSavedBack === false → return) qui peut ignorer la sauvegarde
    // silencieusement. Sur Firefox, une sauvegarde concurrente déclenchait alors isEndRecupDuplicableSectionName
    // prématurément → addNewDuplicableEntity appelé avant que le formulaire soit sauvegardé → HTTP 500.
    // saveFormWithCallback() n'a pas ce guard et garantit que le callback n'est exécuté
    // qu'après la sauvegarde complète (et le rechargement des données duplicables).
    this.saveFormWithCallback(this.indexPage, this.indexPage, () => {
      this.eformDuplicableEntityService.addNewDuplicableEntity(this.avisId, this.lotOrPart).pipe(takeUntil(this.unsubscribeduplicableSection$)).subscribe(duplicableSection => {
        this.prepareIdSchemeListSubject();
        if (duplicableSection?.id?.val) {
          this.eformDuplicableEntityService.actuaEntityIndex = +(duplicableSection.id.val.split('-')[1]) - 1;
          this.eformDuplicableEntityService.actuallyIndexLotOrPar = this.eformDuplicableEntityService.actuaEntityIndex;
        }
        this.eformDuplicableEntityService.actualSectionDuplicableCount++;
        this.eformDuplicableEntityService.stepperLotPageCount++;
        this.eformDuplicableEntityService.currentDuplicableSectionValue.next(duplicableSection);
        this.eformDynamicListService.form = cloneDeep(this.form);
        this.eformDynamicListService.setLotName(cloneDeep(this.form)?.controls?.eforms, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('LOT') || e.id.includes('PAR')));
        const actualStep: StepperModels = Object.assign({}, JSON.parse(JSON.stringify(this.stepper[stepIndex])));
        let stepToGo = +this.stepperBuilderService.duplicateStepForStepper(actualStep);
        this.goTo(stepToGo, true);
      });
    });
  }

  deleteStep(index, step) {
    // 🔧 FIX Firefox 2026-04-07: Même correction que newStep() — utiliser saveFormWithCallback
    // pour garantir que la sauvegarde est terminée avant de supprimer l'entité côté backend.
    this.saveFormWithCallback(this.indexPage, this.indexPage, () => {
      //On diminue le compteur de 1 et remet le lastIndexes sur le premier
      this.indexTrackerService.removeDuplicableElement(this.lotOrPart);
      //Suppression dans flatFields
      this.eformConditionsV2Service.removeDuplicableFieldByTypeAndIndex(this.lotOrPart, step.value - 1);
      //suppression du lot enregistré en BDD à partir de l'id de l'avis et de l'index du lot
      this.eformDuplicableEntityService.deleteDuplicableEntity(this.avisId, step.value, this.lotOrPart).subscribe(() => {
        this.prepareIdSchemeListSubject();
        this.eformDuplicableEntityService.actualSectionDuplicableCount--;
        this.eformDuplicableEntityService.stepperLotPageCount--;
        this.eformDuplicableEntityService.getDuplicableEntity(this.avisId, 1, this.lotOrPart).subscribe((duplicableSection) => {
          this.eformDuplicableEntityService.currentDuplicableSectionValue.next(duplicableSection);
          this.eformDynamicListService.form = cloneDeep(this.form);
          // Utiliser step.id au lieu de index pour supprimer la bonne step
          this.stepperBuilderService.deleteStepIntoStepper(step.id);
          this.eformDynamicListService.setLotName(cloneDeep(this.form).controls.eforms, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('LOT') || e.id.includes('PAR')));
          this.goTo(this.eformDuplicableEntityService.initialSectionDuplicableIndex, true);

          // Force rescan de flatFields après la suppression pour synchroniser avec le formulaire
          this.eformConditionsV2Service.forceRescanAfterDeletion(this.form, this.lotOrPart, step.value - 1);
        });
      });
    });
  }

  isOnError(step, sectionIndex ?) {
    if (this.isEform) {
      let _idStep;
      if (step.eformName) {
        _idStep = step.eformName;
        //Pour les sections repetable le libelle commence par ND mais les erreurs sont enregistrées en GR donc on le remplace
        if (_idStep.includes('ND')) {
          _idStep = _idStep.replace('ND', 'GR');
        }
        //Si on cherche a savoir si une step contient des erreurs (dans une ou plusieurs sections)
        if (sectionIndex === undefined && step.sections.length > 0) {
          let bool = false;
          step.sections.forEach((s, index) => {
            let tempIdStep = _idStep;
            if (!tempIdStep.includes('_') && tempIdStep.includes('GR')) {
              tempIdStep = tempIdStep + '_' + (+step.value - 1) + '_' + index;
            }
            bool = bool || this.stepperBuilderService.getStepFieldsOnErrors(tempIdStep).length > 0;
          });
          return bool;
          //Si on cherche a savoir si une sous-step ou section contient des erreurs
        } else if (sectionIndex !== undefined) {
          _idStep = _idStep + '_' + (+step.value - 1) + '_' + sectionIndex;
          return this.stepperBuilderService.getStepFieldsOnErrors(_idStep).length > 0;
        } else {
          const stepBaseId = _idStep + '_' + (+step.value - 1);
          const keys = Array.from(this.stepperBuilderService.stepFieldsOnErrors.keys());
          let hasErrors = false;

          for (const key of keys) {
            if (key.startsWith(stepBaseId)) {
              if (this.stepperBuilderService.getStepFieldsOnErrors(key).length > 0) {
                hasErrors = true;
                break;
              }
            }
          }
          return hasErrors;
        }
      }
      if (step.libelle !== 'Validation') {
        _idStep = step.libelle + '_' + (+step.value - 1) + '_0';
        return this.stepperBuilderService.getStepFieldsOnErrors(_idStep).length > 0;
      } else {
        return this.haveValidationErrors(sectionIndex);
      }
    } else {
      if (step.libelle.indexOf('stepper.form.commun.stepValider') < 0) {
        return this.stepperBuilderService.getStepFieldsOnErrors(step.prefix).length > 0 && this.stepperBuilderService.getIsCheckValidate(step.prefix);
      } else {
        return this.haveValidationErrors(sectionIndex);
      }
    }
  }

  isOnWarning(step, sectionIndex?) {
    if (this.isEform) {
      let _idStep;
      if (step.libelle.includes('|')) {
        _idStep = step.libelle.split('|').pop();
        if (_idStep.includes('ND')) {
          _idStep = _idStep.replace('ND', 'GR');
        }
        if (sectionIndex === undefined && step.sections.length > 0) {
          let bool = false;
          step.sections.forEach((s, index) => {
            let tempIdStep = _idStep; // Utiliser une variable temporaire
            if (!tempIdStep.includes('_') && tempIdStep.includes('GR')) {
              tempIdStep = tempIdStep + '_' + (+step.value - 1) + '_' + index;
            }
            bool = bool || this.stepperBuilderService.getStepFieldsOnWarnings(tempIdStep).length > 0;
          });
          return bool;
        } else if (sectionIndex !== undefined) {
          _idStep = _idStep + '_' + (+step.value - 1) + '_' + sectionIndex;
          return this.stepperBuilderService.getStepFieldsOnWarnings(_idStep).length > 0;
        } else {
          _idStep += '_' + (+step.value - 1) + '_0';
        }
      }
      if (step.libelle !== 'Validation') {
        _idStep = step.libelle + '_' + (+step.value - 1) + '_0';
        return this.stepperBuilderService.getStepFieldsOnWarnings(_idStep).length > 0;
      } else {
        return this.haveValidationWarnings(sectionIndex);
      }
    } else {
      if (step.libelle.indexOf('stepper.form.commun.stepValider') < 0) {
        return this.stepperBuilderService.getStepFieldsOnWarnings(step.prefix).length > 0 && this.stepperBuilderService.getIsCheckValidate(step.prefix);
      } else {
        return this.haveValidationWarnings(sectionIndex);
      }
    }

  }

  getForm(str: string) {
    return this.stepperBuilderService.formulaire?.toString().includes(str);
  }

  disableIfErrorInSection() {
    if (!this.isEform) {
      return false;
    }
    let list = this.stepperBuilderService.errorsEformBySection;
    return list.length > 0;
  }

  private initEformStepper(data, lotCounter) {
    this.createStepsFromJson(data, lotCounter);
    this.addLotsToStepper(lotCounter);
    this.addValidation();

    // PRB0052503:  F16->F29 5 lots - Perte de saisie des critères d'attribution et messages d'erreur non conformes
    // rafraichîr la page pour reprendre les lots créés côté backend au lieu du modèle F29 utilisé par le front
    this.eformDuplicableEntityService.isFormReady.pipe(first(isEnded => isEnded === true)).subscribe(() => {
      if (this.canNavigateInStepperService.eformAllInputCreated === true && this.canNavigateInStepperService.isCreationAvisLie === true) {
        this.canNavigateInStepperService.isCreationAvisLie = false;
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/accueil', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      } else if (!this.canNavigateInStepperService.isCreerAvisLierSelected) {
        this.goTo(this.indexPage);
      }
    });


    if (this.canNavigateInStepperService.eformCreatingChange) {
      this.eformDuplicableEntityService.duplicableSectionChargeEnded.pipe(first(value => value === true)).subscribe(() => {
        this.saveForm(this.idStepChange, this.idStepChange);
        const rawLotValue = this.stepper[this.stepId] ? this.stepper[this.stepId]?.value : 1;
        const adjustedLotValue = rawLotValue;
        this.eformDuplicableEntityService.getDuplicableEntity(this.avisId, adjustedLotValue, this.lotOrPart).subscribe(duplicableSection => {
          this.eformDuplicableEntityService.currentDuplicableSectionValue.next(duplicableSection);
          this.isEndRecupDuplicableSectionName.next(false);
          this.isEndRecupDuplicableSectionName.pipe(first(isEnded => isEnded === true)).subscribe(() => {
            this.eformDynamicListService.setLotName(cloneDeep(this.form)?.controls?.eforms, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('LOT') || e.id.includes('PAR')));
            this.canNavigateInStepperService.eformCreatingChange = false;
          });
        });
      });
    } else {
      this.cd.detectChanges();
    }
  }

  private createStepsFromJson(data, lotCounter) {
    this.stepper = this.stepper?.slice(0, 1);
    this.stepperBuilderService.subSections = this.stepperBuilderService.subSections.filter(e => e < 1);
    this.isEform = true;
    let eformIndex = 1;
    let previousId: string = '';
    let stepAfterLot: boolean = false;
    //Index qui indique si la step a été dupliquée si oui combien de fois sinon 1
    let valueCounter = 1;
    for (const stepId in data.content) {
      let subIndex = 0;
      if (!data.content[stepId].id.includes('LotsGroup') && (!data.content[stepId].id.includes('Change') || this.canNavigateInStepperService.eformMotifChange)) {
        const step = new StepperModels();
        if (stepAfterLot === true && lotCounter > 0) {
          eformIndex = eformIndex + lotCounter - 1;
          stepAfterLot = false;
        }
        step.id = eformIndex;
        if (data.content[stepId].id === 'GR-Lot' || data.content[stepId].id === 'GR-Part') {
          stepAfterLot = true;
        }
        if (data.content[stepId].id === previousId) {
          valueCounter++;
        } else {
          valueCounter = 1;
        }
        step.value = valueCounter;
        step.required = false;
        step.eformName = data.content[stepId].id;
        if (data.content[stepId]._label.includes('Change')) {
          if (this.canNavigateInStepperService.eformMotifChange.includes('cancel')) {
            step.libelle = 'motif_modification.cancel';
          } else {
            step.libelle = 'motif_modification.changement';
          }
        } else {
          step.libelle = data.content[stepId]._label;
        }
        step.repeatable = !!data.content[stepId]._repeatable;
        let sections = [];
        //On ajoute les sections à la step
        for (const sectionId in data.content[stepId].content) {
          const section = data.content[stepId].content[sectionId];
          if (section.displayType === 'SECTION') {
            subIndex++;
            let newSection = new Section();
            newSection.id = Number(eformIndex + '.' + subIndex);
            newSection.code = Number(eformIndex + '.' + subIndex);
            newSection.intitule = section._label;
            sections.push(newSection);
            this.stepperBuilderService.subSections.push(newSection.code);
          }
        }
        step.sections = sections;
        //Si on n'a pas ajouté de sections dans la step, il faut au moins l'initialiser en ajoutant l'index
        if (subIndex === 0) {
          this.stepperBuilderService.subSections.push(eformIndex);
        }
        this.stepper.push(step);
        if (step.libelle.includes('Change') || step.libelle.includes('cancel') || step.libelle.includes('changement')) {
          this.idStepChange = step.id;
          this.goTo(this.idStepChange, this.idStepChange !== 0 && this.idStepChange != null);
        }
        eformIndex++;
        previousId = data.content[stepId].id;
      }
    }
  }

  private addLotsToStepper(lotCounter, haveToPrepareIdScheme = true) {
    let index = 0;
    //Pour les lots, il faut en créer autant que le back nous l'indique
    //On récupère l'index du lot
    index = this.stepper.findIndex(step => 'GR-Lot' === step.eformName);
    //S'il n'y pas de lots, il peut y avoir des parts
    if (index === 0 || index === -1) {
      index = this.stepper.findIndex(step => 'GR-Part' === step.eformName);
    }
    if (index > 0) {
      this.eformDuplicableEntityService.initialSectionDuplicableIndex = index;
      // ✅ FIX 2026-03-31: Garantir au minimum 1 car le step LOT/PAR existe dans le stepper
      // même si le backend n'a pas encore dupliqué les éléments duplicables (cas avis lié MODIF_MARCHE).
      // Sans ce minimum, getSectionDuplicableIndexes() retourne [] et haveToHide() n'applique pas
      // le décalage nécessaire, ce qui décale toutes les sections après le LOT d'une position :
      // Résultat affiche le contenu de Modification, et Modification est vide.
      this.eformDuplicableEntityService.stepperLotPageCount = Math.max(lotCounter, 1);
      //On récupère la step du lot
      let stepLot = this.stepper[index];

      // 🔧 FIX 2026-04-13: Compter le nombre de lots à ajouter pour décaler les steps suivantes
      const lotsToAdd = lotCounter - 1;

      //On la duplique x fois - 1 car il faut prendre en compte le lot initial
      for (let i = 0; i < lotsToAdd; i++) {
        let lotCopy = Object.assign({}, JSON.parse(JSON.stringify(stepLot)));
        //On met à jour l'id et value qui permet de savoir cb de duplications on a fait
        lotCopy.id = stepLot.id + i + 1;
        lotCopy.value = stepLot.value + i + 1;
        let subsectionsToAdd = [];
        //On met à jour les sous-sections
        for (let j = 0; j < lotCopy.sections.length; j++) {
          lotCopy.sections[j].id = +lotCopy.sections[j].id + i + 1;
          lotCopy.sections[j].code = +lotCopy.sections[j].code + i + 1;
          subsectionsToAdd.push(lotCopy.sections[j].code);
        }
        //Ajout des ids sous-sections dans le stepperBuilderService pour savoir ou aller en cas de précédent ou suivant
        this.stepperBuilderService.subSections = this.stepperBuilderService.insertAndShift(subsectionsToAdd, this.stepperBuilderService.subSections);
        //Finalement, on ajoute la step au stepper
        this.stepper.splice(index + i + 1, 0, lotCopy);
      }

      // 🔧 FIX 2026-04-13: Mettre à jour les IDs et codes de section des steps situées après les lots ajoutés.
      // Sans cette mise à jour, les steps Result, Review et Validation gardent leurs anciens IDs/codes
      // qui entrent en collision avec les codes de section des lots ajoutés.
      // Exemple : Lot 4 a le code 7.1 et Facturation (Validation) aussi → les deux s'affichent en même temps.
      // Note : les subSections sont déjà correctement décalées par insertAndShift() dans la boucle ci-dessus.
      if (lotsToAdd > 0) {
        const lastLotIndex = index + lotsToAdd; // index du dernier lot ajouté dans le stepper
        for (let s = lastLotIndex + 1; s < this.stepper.length; s++) {
          this.stepper[s].id += lotsToAdd;
          if (this.stepper[s].sections && this.stepper[s].sections.length > 0) {
            this.stepper[s].sections.forEach(section => {
              section.id += lotsToAdd;
              section.code += lotsToAdd;
            });
          }
        }
      }

      if (this.avisId && haveToPrepareIdScheme) {
        this.prepareIdSchemeListSubject();
      }
    }
  }

  private updateStepperIfNeeded() {
    let notice = this.stepperBuilderService.notice.getValue();
    if (notice && notice.sections.filter(e => e.id.includes('_') >= 1)) {
      notice.sections.forEach(step => {
        if (step.id.includes('_') && this.stepper.length > 1) {
          let stepIndexForCopy = step.index - step.id.split('_')[1];
          this.stepperBuilderService.duplicateStepForStepper(this.stepper[stepIndexForCopy]);
        }
      });
      this.stepperBuilderService.stepper.next(this.stepper);
    }
  }

  private copyCustomValidations(source: FormGroup, target: FormGroup) {
    Object.keys(source.controls).forEach(key => {
      const sourceControl = source.get(key);
      const targetControl = target.get(key);

      if (sourceControl && targetControl && key.startsWith('_STEP_ID_')) {
        const newValue = {
          ...targetControl.value,
          ctrlValidation: sourceControl.value?.ctrlValidation || false,
          validation_message: sourceControl.value?.validation_message || null
        };

        targetControl.patchValue(newValue, {emitEvent: false});

        targetControl.updateValueAndValidity();
      }
    });
  }

  private validateStep(stepId, isValidateStep, exportXML) {
    if (this.stepperBuilderService.formulaire == null) {
      return;
    }
    //on merge le formTemp de la section dans le form principal si une section est en attente afin de supprimer le bon objet
    if (this.isEform) {
      //Verifie si on doit retirer un schemeId qu'on aurait prérempli et non utilisé
      //Ici on ne remplace pas le form par l'updatedForm car il s'agit d'un control intermédiaire, l'utilisateur peu changer d'avis et remplir un objet contenant un schemeId qui était vide
      //On supprimera vraiment les objets vide à l'envoi
      this.idSchemeService.checkIfSchemeIdHaveToBeDeleted(cloneDeep(this.form), this.formulaireName).then(updatedForm => {
        //Validation du formulaire
        this.avisExtractorService.validateForm(updatedForm, this.referenceAvis, stepId, exportXML, this.facturationIndex, null);
        this.copyCustomValidations(updatedForm, this.form);
        this.stepperBuilderService.addStep('_STEP_ID_SepSep_TypeFacturation', true);
        this.stepperBuilderService.addStep('_STEP_ID_SepSep_TypeIndexation', true);
        this.stepperBuilderService.addStep('_STEP_ID_SepSep_idAnnonceur', true);
      });
    } else {
      this.avisExtractorService.validateForm(this.form, this.referenceAvis, stepId, exportXML, this.facturationIndex, null);
      if (isValidateStep) {
        if (stepId === this.facturationIndex) {
          this.stepperBuilderService.setIsCheckValidate('_STEP_ID_SepSep_TypeFacturation', true);
        } else if (stepId === this.indexationIndex) {
          this.stepperBuilderService.setIsCheckValidate('_STEP_ID_SepSep_TypeIndexation', true);
        } else if (stepId === this.annonceurIndex) {
          this.stepperBuilderService.setIsCheckValidate('_STEP_ID_SepSep_idAnnonceur', true);
        } else {
          this.stepperBuilderService.setIsCheckValidate('_STEP_ID_' + stepId, true);
        }
      }
    }
  }

  private prepareIdSchemeListSubject(avisIdParam?: number) {
    if (this.isEform) {
      const avisId = avisIdParam || this.avisId;
      if (!avisId) {
        return; // Pas d'avisId, on ne peut pas charger les éléments duplicables
      }

      // Attendre que les données complètes de l'avis soient disponibles pour pouvoir
      // enrichir la liste avec les éléments qui n'ont pas d'ID technique
      this.eformDuplicableEntityService.avisWithElementsDuplicable.pipe(
        first(data => data !== null)
      ).subscribe(() => {
        this.eformDuplicableEntityService.getIdsAndNamesByAvisId(avisId).subscribe(listIdsAndNames => {
          // Si on a besoin d'une seconde organisation et qu'il n'y a qu'une seule, on crée la deuxième côté backend
          const orgElements = listIdsAndNames.filter(e => e && e.id && e.id.includes('ORG'));
          // ✅ FIX 2026-02-04: Utiliser wasInitiallyCreationMode au lieu de onModification
          // onModification devient true après la première sauvegarde, ce qui empêchait la création
          // de la 2ème organisation même lors de la création initiale d'un F16.
          // wasInitiallyCreationMode reste false uniquement si on a ouvert un avis existant en édition.
          const isEditingExistingAvis = !this.wasInitiallyCreationMode;
          const isAvisLie = this.canNavigateInStepperService.isAvisLieCreate || this.canNavigateInStepperService.isCreerAvisLierSelected;

          // Conditions pour créer automatiquement la 2ème organisation :
          // 1. needSecondOrganization est true (le formulaire l'exige)
          // 2. Il n'y a qu'une seule organisation
          // 3. L'organisation n'a pas déjà été ajoutée dans cette session
          // 4. Ce n'est PAS un avis lié (le backend gère déjà ce cas)
          // 5. Ce n'est PAS un avis en mode édition (l'utilisateur peut avoir supprimé volontairement)
          if (this.eFormsOrgService.getNeedSecondOrganization() && orgElements.length === 1 && !this.secondOrgAlreadyAdded && !isAvisLie && !isEditingExistingAvis) {
            // Désactiver immédiatement pour éviter les appels multiples
            this.secondOrgAlreadyAdded = true;
            this.eFormsOrgService.setNeedSecondOrganization(false);
            // Créer la deuxième organisation côté backend
            this.eformDuplicableEntityService.addNewDuplicableEntity(avisId, 'ORG').subscribe(() => {
              // Recharger la liste après création
              this.eformDuplicableEntityService.getIdsAndNamesByAvisId(avisId).subscribe(updatedList => {
                this.updateIdSchemeList(updatedList);
              });
            });
          } else {
            this.updateIdSchemeList(listIdsAndNames);
          }
        });
      });
    }
  }

  private updateIdSchemeList(listIdsAndNames: any[]) {
    this.eformDuplicableEntityService.listDuplicableEntity.next(listIdsAndNames);

    this.eformDuplicableEntityService.actualSectionDuplicableCount = listIdsAndNames.filter(e => e && e.id && (e.id.includes('LOT') || e.id.includes('PAR'))).length;
    this.eformDynamicListService.setLotName(cloneDeep(this.form)?.controls?.eforms, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('LOT') || e.id.includes('PAR')));
    this.eformDynamicListService.setOrganizationName(cloneDeep(this.form)?.controls?.eforms, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('ORG')));
    this.eformDynamicListService.setOfferName(cloneDeep(this.form)?.controls?.eforms, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('TEN')));
    this.eformDynamicListService.setTendererName(cloneDeep(this.form)?.controls?.eforms, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('TPA')));

    let listIdScheme = this.eformsSubjectService.idSchemeListSubject.getValue().filter(e => !Object.values(DuplicableElementsIdSchemeEnum).includes(e.split('-')[0]));

    for (const idAndName of listIdsAndNames) {
      if (idAndName && idAndName.id) {
        listIdScheme.push(idAndName.id);
      }
    }
    this.eformsSubjectService.idSchemeListSubject.next(listIdScheme);
    this.isEndRecupDuplicableSectionName.next(true);
    this.cd.detectChanges();
  }

  private updateDataAndRedirect(data, isSaveAndExit) {
    this.onModification = true;
    this.avisId = data.avisId;
    this.stepperBuilderService.avisId = this.avisId;
    this.referenceAvis = data.reference;
    this.flux = data.flux;
    this.formulaireService.actualFormIdAnnEmetteur.next(data.jsonSaisieFormulaire.ann.idAnnEmetteur);
    if (isSaveAndExit) {
      this.router.navigate(['/avisdepublicite/listerAvisPub']);
    }
  }

  private haveValidationErrors(sectionIndex) {
    if (sectionIndex === undefined) {
      return (this.stepperBuilderService.facturationErrorCount && this.stepperBuilderService.getIsCheckValidate('_STEP_ID_SepSep_TypeFacturation')) ||
        (this.stepperBuilderService.indexationErrorCount && this.stepperBuilderService.getIsCheckValidate('_STEP_ID_SepSep_TypeIndexation')) ||
        (this.stepperBuilderService.annonceurErrorCount && this.stepperBuilderService.getIsCheckValidate('_STEP_ID_SepSep_idAnnonceur')) ||
        this.stepperBuilderService.validationErrorCount;
    } else if (sectionIndex === 0) {
      return this.stepperBuilderService.facturationErrorCount && this.stepperBuilderService.getIsCheckValidate('_STEP_ID_SepSep_TypeFacturation');
    } else if (sectionIndex === 1) {
      return this.stepperBuilderService.indexationErrorCount && this.stepperBuilderService.getIsCheckValidate('_STEP_ID_SepSep_TypeIndexation');
    } else if (sectionIndex === 2) {
      if (this.fadIndex && this.fadIndex !== 1) {
        return 0;
      } else {
        return this.stepperBuilderService.annonceurErrorCount && this.stepperBuilderService.getIsCheckValidate('_STEP_ID_SepSep_idAnnonceur');
      }
    } else if (sectionIndex === 3) {
      if (this.fadIndex && this.fadIndex !== 1) {
        return this.stepperBuilderService.annonceurErrorCount && this.stepperBuilderService.getIsCheckValidate('_STEP_ID_SepSep_idAnnonceur');
      } else {
        return this.stepperBuilderService.validationErrorCount;
      }
    } else if (sectionIndex === 4 && this.fadIndex && this.fadIndex !== 1) {
      return this.stepperBuilderService.validationErrorCount;
    }
  }

  private haveValidationWarnings(sectionIndex) {
    if (sectionIndex === undefined) {
      return this.stepperBuilderService.facturationWarningCount;
    } else if (sectionIndex === 0) {
      return this.stepperBuilderService.facturationWarningCount;
    } else {
      return 0;
    }
  }

  /**
   * 🔧 FIX 2026-03-09: Initialise les structures manquantes pour les avis de modification.
   * Problème: Quand on crée un avis de modification depuis un avis publié, le backend copie
   * les structures de l'avis original, mais certaines structures comme BT-615-Lot
   * (documents restreints) ne sont pas créées si elles n'existaient pas dans l'avis original.
   * Cela provoque des erreurs de validation côté front car les champs conditionnels cherchent
   * des structures qui n'existent pas.
   *
   * Solution: Initialiser les structures manquantes au chargement de l'avis de modification.
   * Cela complète le travail du backend et garantit que toutes les structures nécessaires existent.
   */
  private initMissingStructuresForChangeNotice(data: any): void {
    // Trouver la notice (contractNotice, priorInformationNotice, etc.)
    const ann = data.jsonSaisieFormulaire?.ann;
    if (!ann) {
      return;
    }

    let notice = null;

    if (ann.contractNotice) {
      notice = ann.contractNotice;
    } else if (ann.priorInformationNotice) {
      notice = ann.priorInformationNotice;
    } else if (ann.contractAwardNotice) {
      notice = ann.contractAwardNotice;
    }

    if (!notice) {
      return;
    }

    const lots = notice.procurementProjectLot || [];

    // Pour chaque lot, vérifier et initialiser les structures manquantes
    lots.forEach((lot, lotIndex) => {
      if (!lot.tenderingTerms) {
        return;
      }

      // Initialiser callForTendersDocumentReference[] si manquant
      if (!lot.tenderingTerms.callForTendersDocumentReference) {
        lot.tenderingTerms.callForTendersDocumentReference = [];
      }

      // Vérifier si un élément avec documenttype="restricted-document" existe
      const hasRestrictedDoc = lot.tenderingTerms.callForTendersDocumentReference.some(doc =>
        doc.documentType?.some(dt => dt.listName === 'communication-justification')
      );

      if (!hasRestrictedDoc) {
        // Créer la structure pour BT-615-Lot (documents restreints)
        const restrictedDocRef = {
          copyIndicator: null,
          documentDescription: [],
          ublExtensions: null,
          issueTime: null,
          documentType: [{
            val: null,
            listName: 'communication-justification',
            inputId: 'BT-737-Lot',
            languageID: 'FRA'
          }],
          documentStatusCode: null,
          languageID: null,
          issuerParty: null,
          uuid: null,
          resultOfVerification: null,
          validityPeriod: null,
          versionID: null,
          documentTypeCode: null,
          localeCode: null,
          attachment: {
            externalReference: {
              expiryDate: null,
              formatCode: null,
              documentHash: null,
              encodingCode: null,
              filename: null,
              hashAlgorithmMethod: null,
              expiryTime: null,
              mimeCode: null,
              uri: {
                val: null,
                inputId: 'BT-615-Lot',
                schemeDataURI: null,
                schemeURI: null,
                schemeName: null,
                schemeID: null,
                schemeVersionID: null,
                schemeAgencyID: null,
                schemeAgencyName: null
              },
              description: []
            },
            ublExtensions: null,
            embeddedDocumentBinaryObject: null,
            embeddedDocument: null
          },
          id: null,
          issueDate: null,
          xPath: [],
          referencedDocumentInternalAddress: null
        };

        lot.tenderingTerms.callForTendersDocumentReference.push(restrictedDocRef);
      }
    });
  }
}
